/* tslint:disable */
/* eslint-disable */
/**
 * Distributor API
 * The Cashlink Distributor API enables you to distribute crypto securities and digital securities. It contains all building blocks from investor registration and KYC/AML to brokerage, clearing and settlement processes. While you are in full control of the frontends served to your investors you can use the Cashlink Studio to monitor and manage the activity on your platform.   Note: You cannot access data of investors or investments if they haven\'t been created via the API with your provided API credentials. Also, it\'s not possible to access data of investors that have registered via the Cashlink Signing Module, if you are using this as well.  ### Authentication  Every call to the API must be authenticated via OAuth client credentials. During setup, your point of contact will provide you with your client ID and client secret.   ### Idempotency  For certain POST endpoints, the API uses client-supplied idempotency keys to ensure that requests can be retried safely without performing the same operation twice. Repeated calls to those endpoints with the same idempotency key will return the cached response from the first call. Keys are expected to be set as header parameters with *X-Idempotency-Key*. The recommended approach for interacting with such endpoints is as follows:   - Create a unique, random key, such as a UUIDv4.   - Store the intent to call an endpoint along with the generated key in the client database.   - Flush to disk (e.g. commit an SQL transaction).   - Perform the call to the endpoint.   This ensures that even if the response from the API to a client gets lost, or the client experiences any sort of outage between steps 3 and 4, the client can always safely retry the same action.   If you already have objects corresponding to tasks in the API in your client-side database, you can use their internal IDs as idempotency keys!   ### Monetary values   Monetary values are represented as a combination of amount, decimals & currency. For example, ```{\'amount\': \'40000000\', \'decimals\': 3, \'currency\': \'EUR\'} means \'EUR 40,000.000\'```.   ### Handling documents  The document endpoint can be used to upload documents. Files are uploaded via HTTP multipart. The endpoint will return a document ID that can be used in other requests to refer to that document.   ### Webhooks  You can also register webhooks so that we can notify your application about events with regards to investments. To use that, please provide your point of contact at Cashlink with the following data:   - URL to be used as the target for webhooks  - OAuth client credentials or bearer authentication token so that we can authenticate at your server.  Webhooks are sent every time the status of an investment changes.  **POST <customer-provided URL>**  Webhooks are retried until the called endpoint returns a 2xx.  **Request**  {  \'investment_id\': \'3fa85f64-5717-4562-b3fc-2c963f66afa6\',  \'status\': \'ACCEPTED\',  \'changed_at\': \'2020-12-11T14:59:46.716Z\'  }  ### Concepts  The Cashlink Distributor API is based on the following concepts:  - Persons (legal or natural) that are users on your platform willing to invest are called investors.  - These investors will be able to invest into different financial products issued by different entities. In the API they are called products.  - The purchase of units of such a product takes place within your application and ends with a signed investment contract.  - Now you can create an investment, which contains the investor, the units, the signed investment contract and the accepted date of the investment by the issuer.   - At some point, parts of the investments are returned to the issuer because the outstanding amount has been paid back for example. Such a transaction is called a redemption.    
 *
 * The version of the OpenAPI document: 2.22.0
 * Contact: support@cashlink.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminBulkInvestmentDocumentCreation,
  AdminBulkInvestmentDocumentCreationRequest,
  AdminBundesbankSettlementInstruction,
  AdminBundesbankSettlementInstructionRequest,
  AdminCampaign,
  AdminDistributorProductDistributionInformation,
  AdminDistributorProductDistributionInformationRequest,
  AdminDocument,
  AdminGenericWalletCreation,
  AdminGenericWalletCreationRequest,
  AdminInvestmentCreation,
  AdminInvestmentCreationRequest,
  AdminInvestmentDetails,
  AdminInvestmentDetailsRequest,
  AdminInvestmentDocument,
  AdminInvestor,
  AdminInvestorCreation,
  AdminInvestorCreationRequest,
  AdminInvestorList,
  AdminInvitation,
  AdminIssuerCreationRequest,
  AdminIssuerDetail,
  AdminLegalPersonUpdate,
  AdminLegalPersonUpdateRequest,
  AdminMail,
  AdminPayoutEvent,
  AdminPayoutEventCreationOrUpdate,
  AdminPayoutEventCreationOrUpdateRequest,
  AdminPendingInvestorDeletion,
  AdminPendingInvestorDeletionRequest,
  AdminProductCreationRequest,
  AdminProductDetail,
  AdminProductDistributionPlatformListing,
  AdminProductDistributionPlatformListingCreation,
  AdminProductDistributionPlatformListingCreationRequest,
  AdminTokenGlobalOverview,
  AdminTokenOverview,
  AdminTokenTransfer,
  AdminVersionedIssuanceDocument,
  AdminVersionedIssuanceDocumentRequest,
  AdminVoucherCreation,
  AdminVoucherCreationRequest,
  AdminVoucherDetail,
  AdminVoucherRequest,
  AdminVoucherStep,
  AdminVoucherStepBulkCreateRequest,
  AdminVoucherValidator,
  AdminVoucherValidatorRequest,
  BenefitingPerson,
  BenefitingPersonRequest,
  Campaign,
  CampaignActivationRequest,
  CampaignRequest,
  CreateRegistryStatementRequest,
  Identification,
  IdentificationRequest,
  InvestmentCalculation,
  InvestmentCancellationRequest,
  InvestmentInvitation,
  InvestmentInvitationCreationRequest,
  InvestmentIssuingAnnouncementRequest,
  IssuerInvestmentRules,
  KycInformation,
  PaginatedAdminBundesbankSettlementInstructionList,
  PaginatedAdminCampaignList,
  PaginatedAdminInvestmentList,
  PaginatedAdminInvestorListList,
  PaginatedAdminIssuerListList,
  PaginatedAdminMailList,
  PaginatedAdminPayoutEventList,
  PaginatedAdminProductDetailList,
  PaginatedAdminProductDistributionPlatformListingList,
  PaginatedAdminRegistryStatementList,
  PaginatedAdminVoucherList,
  PaginatedIdentificationList,
  PaginatedInvestmentDetailsList,
  PaginatedInvitationList,
  PatchedAdminDistributorProductDistributionInformationRequest,
  PatchedAdminInvestmentDetailsRequest,
  PatchedAdminInvestorUpdateRequest,
  PatchedAdminIssuerUpdateRequest,
  PatchedAdminPayoutEventRequest,
  PatchedAdminProductDetailRequest,
  PatchedAdminVoucherUpdateRequest,
  PatchedBenefitingPersonRequest,
  PatchedWalletUpdateRequest,
  Redemption,
  RedemptionRequest,
  Statistics,
  WalletUpdate,
} from '../models/index';
import {
    AdminBulkInvestmentDocumentCreationFromJSON,
    AdminBulkInvestmentDocumentCreationToJSON,
    AdminBulkInvestmentDocumentCreationRequestFromJSON,
    AdminBulkInvestmentDocumentCreationRequestToJSON,
    AdminBundesbankSettlementInstructionFromJSON,
    AdminBundesbankSettlementInstructionToJSON,
    AdminBundesbankSettlementInstructionRequestFromJSON,
    AdminBundesbankSettlementInstructionRequestToJSON,
    AdminCampaignFromJSON,
    AdminCampaignToJSON,
    AdminDistributorProductDistributionInformationFromJSON,
    AdminDistributorProductDistributionInformationToJSON,
    AdminDistributorProductDistributionInformationRequestFromJSON,
    AdminDistributorProductDistributionInformationRequestToJSON,
    AdminDocumentFromJSON,
    AdminDocumentToJSON,
    AdminGenericWalletCreationFromJSON,
    AdminGenericWalletCreationToJSON,
    AdminGenericWalletCreationRequestFromJSON,
    AdminGenericWalletCreationRequestToJSON,
    AdminInvestmentCreationFromJSON,
    AdminInvestmentCreationToJSON,
    AdminInvestmentCreationRequestFromJSON,
    AdminInvestmentCreationRequestToJSON,
    AdminInvestmentDetailsFromJSON,
    AdminInvestmentDetailsToJSON,
    AdminInvestmentDetailsRequestFromJSON,
    AdminInvestmentDetailsRequestToJSON,
    AdminInvestmentDocumentFromJSON,
    AdminInvestmentDocumentToJSON,
    AdminInvestorFromJSON,
    AdminInvestorToJSON,
    AdminInvestorCreationFromJSON,
    AdminInvestorCreationToJSON,
    AdminInvestorCreationRequestFromJSON,
    AdminInvestorCreationRequestToJSON,
    AdminInvestorListFromJSON,
    AdminInvestorListToJSON,
    AdminInvitationFromJSON,
    AdminInvitationToJSON,
    AdminIssuerCreationRequestFromJSON,
    AdminIssuerCreationRequestToJSON,
    AdminIssuerDetailFromJSON,
    AdminIssuerDetailToJSON,
    AdminLegalPersonUpdateFromJSON,
    AdminLegalPersonUpdateToJSON,
    AdminLegalPersonUpdateRequestFromJSON,
    AdminLegalPersonUpdateRequestToJSON,
    AdminMailFromJSON,
    AdminMailToJSON,
    AdminPayoutEventFromJSON,
    AdminPayoutEventToJSON,
    AdminPayoutEventCreationOrUpdateFromJSON,
    AdminPayoutEventCreationOrUpdateToJSON,
    AdminPayoutEventCreationOrUpdateRequestFromJSON,
    AdminPayoutEventCreationOrUpdateRequestToJSON,
    AdminPendingInvestorDeletionFromJSON,
    AdminPendingInvestorDeletionToJSON,
    AdminPendingInvestorDeletionRequestFromJSON,
    AdminPendingInvestorDeletionRequestToJSON,
    AdminProductCreationRequestFromJSON,
    AdminProductCreationRequestToJSON,
    AdminProductDetailFromJSON,
    AdminProductDetailToJSON,
    AdminProductDistributionPlatformListingFromJSON,
    AdminProductDistributionPlatformListingToJSON,
    AdminProductDistributionPlatformListingCreationFromJSON,
    AdminProductDistributionPlatformListingCreationToJSON,
    AdminProductDistributionPlatformListingCreationRequestFromJSON,
    AdminProductDistributionPlatformListingCreationRequestToJSON,
    AdminTokenGlobalOverviewFromJSON,
    AdminTokenGlobalOverviewToJSON,
    AdminTokenOverviewFromJSON,
    AdminTokenOverviewToJSON,
    AdminTokenTransferFromJSON,
    AdminTokenTransferToJSON,
    AdminVersionedIssuanceDocumentFromJSON,
    AdminVersionedIssuanceDocumentToJSON,
    AdminVersionedIssuanceDocumentRequestFromJSON,
    AdminVersionedIssuanceDocumentRequestToJSON,
    AdminVoucherCreationFromJSON,
    AdminVoucherCreationToJSON,
    AdminVoucherCreationRequestFromJSON,
    AdminVoucherCreationRequestToJSON,
    AdminVoucherDetailFromJSON,
    AdminVoucherDetailToJSON,
    AdminVoucherRequestFromJSON,
    AdminVoucherRequestToJSON,
    AdminVoucherStepFromJSON,
    AdminVoucherStepToJSON,
    AdminVoucherStepBulkCreateRequestFromJSON,
    AdminVoucherStepBulkCreateRequestToJSON,
    AdminVoucherValidatorFromJSON,
    AdminVoucherValidatorToJSON,
    AdminVoucherValidatorRequestFromJSON,
    AdminVoucherValidatorRequestToJSON,
    BenefitingPersonFromJSON,
    BenefitingPersonToJSON,
    BenefitingPersonRequestFromJSON,
    BenefitingPersonRequestToJSON,
    CampaignFromJSON,
    CampaignToJSON,
    CampaignActivationRequestFromJSON,
    CampaignActivationRequestToJSON,
    CampaignRequestFromJSON,
    CampaignRequestToJSON,
    CreateRegistryStatementRequestFromJSON,
    CreateRegistryStatementRequestToJSON,
    IdentificationFromJSON,
    IdentificationToJSON,
    IdentificationRequestFromJSON,
    IdentificationRequestToJSON,
    InvestmentCalculationFromJSON,
    InvestmentCalculationToJSON,
    InvestmentCancellationRequestFromJSON,
    InvestmentCancellationRequestToJSON,
    InvestmentInvitationFromJSON,
    InvestmentInvitationToJSON,
    InvestmentInvitationCreationRequestFromJSON,
    InvestmentInvitationCreationRequestToJSON,
    InvestmentIssuingAnnouncementRequestFromJSON,
    InvestmentIssuingAnnouncementRequestToJSON,
    IssuerInvestmentRulesFromJSON,
    IssuerInvestmentRulesToJSON,
    KycInformationFromJSON,
    KycInformationToJSON,
    PaginatedAdminBundesbankSettlementInstructionListFromJSON,
    PaginatedAdminBundesbankSettlementInstructionListToJSON,
    PaginatedAdminCampaignListFromJSON,
    PaginatedAdminCampaignListToJSON,
    PaginatedAdminInvestmentListFromJSON,
    PaginatedAdminInvestmentListToJSON,
    PaginatedAdminInvestorListListFromJSON,
    PaginatedAdminInvestorListListToJSON,
    PaginatedAdminIssuerListListFromJSON,
    PaginatedAdminIssuerListListToJSON,
    PaginatedAdminMailListFromJSON,
    PaginatedAdminMailListToJSON,
    PaginatedAdminPayoutEventListFromJSON,
    PaginatedAdminPayoutEventListToJSON,
    PaginatedAdminProductDetailListFromJSON,
    PaginatedAdminProductDetailListToJSON,
    PaginatedAdminProductDistributionPlatformListingListFromJSON,
    PaginatedAdminProductDistributionPlatformListingListToJSON,
    PaginatedAdminRegistryStatementListFromJSON,
    PaginatedAdminRegistryStatementListToJSON,
    PaginatedAdminVoucherListFromJSON,
    PaginatedAdminVoucherListToJSON,
    PaginatedIdentificationListFromJSON,
    PaginatedIdentificationListToJSON,
    PaginatedInvestmentDetailsListFromJSON,
    PaginatedInvestmentDetailsListToJSON,
    PaginatedInvitationListFromJSON,
    PaginatedInvitationListToJSON,
    PatchedAdminDistributorProductDistributionInformationRequestFromJSON,
    PatchedAdminDistributorProductDistributionInformationRequestToJSON,
    PatchedAdminInvestmentDetailsRequestFromJSON,
    PatchedAdminInvestmentDetailsRequestToJSON,
    PatchedAdminInvestorUpdateRequestFromJSON,
    PatchedAdminInvestorUpdateRequestToJSON,
    PatchedAdminIssuerUpdateRequestFromJSON,
    PatchedAdminIssuerUpdateRequestToJSON,
    PatchedAdminPayoutEventRequestFromJSON,
    PatchedAdminPayoutEventRequestToJSON,
    PatchedAdminProductDetailRequestFromJSON,
    PatchedAdminProductDetailRequestToJSON,
    PatchedAdminVoucherUpdateRequestFromJSON,
    PatchedAdminVoucherUpdateRequestToJSON,
    PatchedBenefitingPersonRequestFromJSON,
    PatchedBenefitingPersonRequestToJSON,
    PatchedWalletUpdateRequestFromJSON,
    PatchedWalletUpdateRequestToJSON,
    RedemptionFromJSON,
    RedemptionToJSON,
    RedemptionRequestFromJSON,
    RedemptionRequestToJSON,
    StatisticsFromJSON,
    StatisticsToJSON,
    WalletUpdateFromJSON,
    WalletUpdateToJSON,
} from '../models/index';

export interface AdminBundesbankSettlementInstructionsListRequest {
    limit?: number;
    offset?: number;
    ordering?: string;
    search?: string;
    status?: string;
}

export interface AdminBundesbankSettlementInstructionsRetrieveRequest {
    id: string;
}

export interface AdminCampaignsActivationCreateRequest {
    id: string;
    campaignActivationRequest?: CampaignActivationRequest;
}

export interface AdminCampaignsInvestmentsCreateRequest {
    id: string;
    adminInvestmentCreationRequest: AdminInvestmentCreationRequest;
}

export interface AdminCampaignsListRequest {
    limit?: number;
    offset?: number;
    ordering?: string;
    tokenId?: string;
}

export interface AdminCampaignsRetrieveRequest {
    id: string;
}

export interface AdminFriendVouchersListRequest {
    active?: boolean;
    alreadyUsedMax?: number;
    alreadyUsedMin?: number;
    code?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    limit?: number;
    name?: string;
    offset?: number;
    ordering?: string;
    search?: string;
}

export interface AdminFriendVouchersRetrieveRequest {
    id: string;
}

export interface AdminInvestmentTransfersListRequest {
    investment: string;
}

export interface AdminInvestmentsCancellationCreateRequest {
    id: string;
    investmentCancellationRequest: InvestmentCancellationRequest;
}

export interface AdminInvestmentsDocumentsListRequest {
    id: string;
}

export interface AdminInvestmentsIssueCreateRequest {
    id: string;
}

export interface AdminInvestmentsIssuingAnnouncementCreateRequest {
    id: string;
    investmentIssuingAnnouncementRequest: InvestmentIssuingAnnouncementRequest;
}

export interface AdminInvestmentsListRequest {
    campaign?: string;
    distributionPlatformId?: string;
    frontendStatus?: AdminInvestmentsListFrontendStatusEnum;
    fulfilledAmountMax?: string;
    fulfilledAmountMin?: string;
    investmentTotalFulfilledMax?: number;
    investmentTotalFulfilledMin?: number;
    investmentTotalMax?: number;
    investmentTotalMin?: number;
    investor?: string;
    investorName?: string;
    limit?: number;
    offset?: number;
    ordering?: string;
    paymentCode?: string;
    paymentTotalMax?: number;
    paymentTotalMin?: number;
    productName?: string;
    search?: string;
    signedDateAfter?: Date;
    signedDateBefore?: Date;
    status?: AdminInvestmentsListStatusEnum;
    step?: AdminInvestmentsListStepEnum;
    tokenId?: string;
}

export interface AdminInvestmentsOfferApprovalCreateRequest {
    id: string;
}

export interface AdminInvestmentsPartialUpdateRequest {
    id: string;
    patchedAdminInvestmentDetailsRequest?: PatchedAdminInvestmentDetailsRequest;
}

export interface AdminInvestmentsPaymentConfirmationCreateRequest {
    id: string;
}

export interface AdminInvestmentsRegistryStatementsCreateRequest {
    id: string;
    createRegistryStatementRequest?: CreateRegistryStatementRequest;
}

export interface AdminInvestmentsRequestIdentificationCreateRequest {
    id: string;
}

export interface AdminInvestmentsRetrieveRequest {
    id: string;
}

export interface AdminInvestmentsUpdateRequest {
    id: string;
    adminInvestmentDetailsRequest: AdminInvestmentDetailsRequest;
}

export interface AdminInvestorsBenefitingPersonConfirmationCreateRequest {
    id: string;
}

export interface AdminInvestorsBenefitingPersonsCreateRequest {
    id: string;
    benefitingPersonRequest: BenefitingPersonRequest;
}

export interface AdminInvestorsBenefitingPersonsDestroyRequest {
    id: string;
    personId: string;
}

export interface AdminInvestorsBenefitingPersonsListRequest {
    id: string;
    ordering?: string;
    search?: string;
}

export interface AdminInvestorsBenefitingPersonsPartialUpdateRequest {
    id: string;
    personId: string;
    patchedBenefitingPersonRequest?: PatchedBenefitingPersonRequest;
}

export interface AdminInvestorsCreateRequest {
    adminInvestorCreationRequest: AdminInvestorCreationRequest;
}

export interface AdminInvestorsDestroyRequest {
    id: string;
}

export interface AdminInvestorsIdentificationsBestCurrentRetrieveRequest {
    id: string;
}

export interface AdminInvestorsIdentificationsCreateRequest {
    id: string;
    identificationRequest: IdentificationRequest;
}

export interface AdminInvestorsIdentificationsListRequest {
    id: string;
    limit?: number;
    offset?: number;
    ordering?: string;
    search?: string;
}

export interface AdminInvestorsIdentificationsRestartCreateRequest {
    id: string;
    identificationRequest: IdentificationRequest;
}

export interface AdminInvestorsIncompleteListRequest {
    activeInvestmentsNoMax?: number;
    activeInvestmentsNoMin?: number;
    activeInvestmentsSumMax?: number;
    activeInvestmentsSumMin?: number;
    distributionPlatformId?: string;
    email?: string;
    lastName?: string;
    name?: string;
    ordering?: string;
    registeredAtAfter?: Date;
    registeredAtBefore?: Date;
    search?: string;
    tokenId?: string;
    tokenIdIsnull?: boolean;
}

export interface AdminInvestorsLegalPersonCreateRequest {
    id: string;
    adminLegalPersonUpdateRequest: AdminLegalPersonUpdateRequest;
}

export interface AdminInvestorsListRequest {
    activeInvestmentsNoMax?: number;
    activeInvestmentsNoMin?: number;
    activeInvestmentsSumMax?: number;
    activeInvestmentsSumMin?: number;
    distributionPlatformId?: string;
    email?: string;
    lastName?: string;
    limit?: number;
    name?: string;
    offset?: number;
    ordering?: string;
    registeredAtAfter?: Date;
    registeredAtBefore?: Date;
    search?: string;
    tokenId?: string;
    tokenIdIsnull?: boolean;
}

export interface AdminInvestorsMailsListRequest {
    id: string;
    limit?: number;
    offset?: number;
    search?: string;
    sendAtAfter?: Date;
    sendAtBefore?: Date;
    type?: AdminInvestorsMailsListTypeEnum;
}

export interface AdminInvestorsPartialUpdateRequest {
    id: string;
    patchedAdminInvestorUpdateRequest?: PatchedAdminInvestorUpdateRequest;
}

export interface AdminInvestorsPendingDeletionCreateRequest {
    id: string;
    adminPendingInvestorDeletionRequest: AdminPendingInvestorDeletionRequest;
}

export interface AdminInvestorsPendingDeletionRetrieveRequest {
    id: string;
}

export interface AdminInvestorsReactivateCreateRequest {
    id: string;
}

export interface AdminInvestorsRetrieveRequest {
    id: string;
}

export interface AdminInvestorsWalletsEthGenericCreateRequest {
    id: string;
    adminGenericWalletCreationRequest: AdminGenericWalletCreationRequest;
}

export interface AdminInvestorsWalletsPartialUpdateRequest {
    id: string;
    walletId: string;
    patchedWalletUpdateRequest?: PatchedWalletUpdateRequest;
}

export interface AdminInvitationsDestroyRequest {
    id: string;
    tokenId?: string;
}

export interface AdminInvitationsIdentificationRetrieveRequest {
    id: string;
    tokenId?: string;
}

export interface AdminInvitationsIdentificationStartNotificationCreateRequest {
    id: string;
    tokenId?: string;
}

export interface AdminInvitationsListRequest {
    campaignId?: string;
    invitationType?: string;
    isEcsp?: boolean;
    limit?: number;
    offset?: number;
    ordering?: string;
    status?: string;
    tokenId?: string;
}

export interface AdminInvitationsRetrieveRequest {
    id: string;
    tokenId?: string;
}

export interface AdminIssuersCreateRequest {
    adminIssuerCreationRequest: AdminIssuerCreationRequest;
}

export interface AdminIssuersListRequest {
    canCreateProduct?: boolean;
    issuerId?: string;
    limit?: number;
    numberOfProductsMax?: number;
    numberOfProductsMin?: number;
    offset?: number;
    search?: string;
}

export interface AdminIssuersPartialUpdateRequest {
    id: string;
    patchedAdminIssuerUpdateRequest?: PatchedAdminIssuerUpdateRequest;
}

export interface AdminIssuersRetrieveRequest {
    id: string;
}

export interface AdminListingsCreateRequest {
    adminProductDistributionPlatformListingCreationRequest: AdminProductDistributionPlatformListingCreationRequest;
}

export interface AdminListingsDistributionInformationCreateRequest {
    id: string;
    adminDistributorProductDistributionInformationRequest: AdminDistributorProductDistributionInformationRequest;
}

export interface AdminListingsDistributionInformationPartialUpdateRequest {
    id: string;
    patchedAdminDistributorProductDistributionInformationRequest?: PatchedAdminDistributorProductDistributionInformationRequest;
}

export interface AdminListingsDistributionInformationRetrieveRequest {
    id: string;
}

export interface AdminListingsInvestmentDocumentsCreateRequest {
    id: string;
    adminBulkInvestmentDocumentCreationRequest: AdminBulkInvestmentDocumentCreationRequest;
}

export interface AdminListingsInvestmentDocumentsRetrieveRequest {
    id: string;
}

export interface AdminListingsListRequest {
    limit?: number;
    offset?: number;
    productId?: string;
    search?: string;
}

export interface AdminListingsRetrieveRequest {
    id: string;
}

export interface AdminMailsResendCreateRequest {
    id: string;
}

export interface AdminMailsRetrieveRequest {
    id: string;
}

export interface AdminPayoutEventsCreateRequest {
    adminPayoutEventCreationOrUpdateRequest: AdminPayoutEventCreationOrUpdateRequest;
}

export interface AdminPayoutEventsListRequest {
    issuerId?: string;
    limit?: number;
    offset?: number;
    paymentDateAfter?: Date;
    paymentDateBefore?: Date;
    payoutEventType?: Array<AdminPayoutEventsListPayoutEventTypeEnum>;
    productId?: string;
}

export interface AdminPayoutEventsPartialUpdateRequest {
    id: string;
    patchedAdminPayoutEventRequest?: PatchedAdminPayoutEventRequest;
}

export interface AdminPayoutEventsRetrieveRequest {
    id: string;
}

export interface AdminRedemptionsCreateRequest {
    redemptionRequest: RedemptionRequest;
}

export interface AdminRedemptionsRetrieveRequest {
    id: string;
}

export interface AdminStatisticsReportRetrieveRequest {
    reportType: AdminStatisticsReportRetrieveReportTypeEnum;
}

export interface AdminTokensBundesbankSettlementInstructionsCreateRequest {
    id: string;
    adminBundesbankSettlementInstructionRequest: AdminBundesbankSettlementInstructionRequest;
}

export interface AdminTokensCalculationsRetrieveRequest {
    id: string;
    pricePerToken?: number;
    requestedTokens?: number;
}

export interface AdminTokensCampaignsCreateRequest {
    id: string;
    campaignRequest: CampaignRequest;
}

export interface AdminTokensCreateRequest {
    adminProductCreationRequest: AdminProductCreationRequest;
}

export interface AdminTokensInvitationCreateRequest {
    id: string;
    investmentInvitationCreationRequest: InvestmentInvitationCreationRequest;
}

export interface AdminTokensInvitationRulesListRequest {
    id: string;
    issuerId?: string;
    search?: string;
    status?: Array<AdminTokensInvitationRulesListStatusEnum>;
    totalVolumeMax?: number;
    totalVolumeMin?: number;
}

export interface AdminTokensIssuanceDocumentCreateRequest {
    id: string;
    adminVersionedIssuanceDocumentRequest: AdminVersionedIssuanceDocumentRequest;
}

export interface AdminTokensListRequest {
    id?: string;
    issuerId?: string;
    limit?: number;
    offset?: number;
    search?: string;
    status?: Array<AdminTokensListStatusEnum>;
    totalVolumeMax?: number;
    totalVolumeMin?: number;
}

export interface AdminTokensOverviewRetrieveRequest {
    id: string;
}

export interface AdminTokensPartialUpdateRequest {
    id: string;
    patchedAdminProductDetailRequest?: PatchedAdminProductDetailRequest;
}

export interface AdminTokensRegistryStatementsListRequest {
    id: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    limit?: number;
    offset?: number;
    search?: string;
}

export interface AdminTokensRetrieveRequest {
    id: string;
}

export interface AdminVouchersActivationCreateRequest {
    id: string;
    adminVoucherRequest: AdminVoucherRequest;
}

export interface AdminVouchersCreateRequest {
    adminVoucherCreationRequest: AdminVoucherCreationRequest;
}

export interface AdminVouchersInvestmentsListRequest {
    id: string;
    campaign?: string;
    distributionPlatformId?: string;
    fulfilledAmountMax?: string;
    fulfilledAmountMin?: string;
    investmentTotalFulfilledMax?: number;
    investmentTotalFulfilledMin?: number;
    investmentTotalMax?: number;
    investmentTotalMin?: number;
    investorName?: string;
    limit?: number;
    offset?: number;
    ordering?: string;
    paymentCode?: string;
    paymentTotalMax?: number;
    paymentTotalMin?: number;
    productName?: string;
    search?: string;
    signedDateAfter?: Date;
    signedDateBefore?: Date;
}

export interface AdminVouchersListRequest {
    active?: boolean;
    alreadyUsedMax?: number;
    alreadyUsedMin?: number;
    code?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    limit?: number;
    name?: string;
    offset?: number;
    ordering?: string;
    search?: string;
}

export interface AdminVouchersPartialUpdateRequest {
    id: string;
    patchedAdminVoucherUpdateRequest?: PatchedAdminVoucherUpdateRequest;
}

export interface AdminVouchersRetrieveRequest {
    id: string;
}

export interface AdminVouchersValidatorCreateRequest {
    adminVoucherValidatorRequest: AdminVoucherValidatorRequest;
}

export interface AdminVouchersVoucherStepsCreateRequest {
    id: string;
    adminVoucherStepBulkCreateRequest: AdminVoucherStepBulkCreateRequest;
    active?: boolean;
    alreadyUsedMax?: number;
    alreadyUsedMin?: number;
    code?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    name?: string;
    ordering?: string;
    search?: string;
}

export interface AdminVouchersVoucherStepsListRequest {
    id: string;
    active?: boolean;
    alreadyUsedMax?: number;
    alreadyUsedMin?: number;
    code?: string;
    createdAtAfter?: Date;
    createdAtBefore?: Date;
    name?: string;
    ordering?: string;
    search?: string;
}

/**
 * 
 */
export class AdminApi extends runtime.BaseAPI {

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminBundesbankSettlementInstructionsListRaw(requestParameters: AdminBundesbankSettlementInstructionsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminBundesbankSettlementInstructionList>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/bundesbank-settlement-instructions/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminBundesbankSettlementInstructionListFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminBundesbankSettlementInstructionsList(requestParameters: AdminBundesbankSettlementInstructionsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminBundesbankSettlementInstructionList> {
        const response = await this.adminBundesbankSettlementInstructionsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminBundesbankSettlementInstructionsRetrieveRaw(requestParameters: AdminBundesbankSettlementInstructionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminBundesbankSettlementInstruction>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminBundesbankSettlementInstructionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/bundesbank-settlement-instructions/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminBundesbankSettlementInstructionFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminBundesbankSettlementInstructionsRetrieve(requestParameters: AdminBundesbankSettlementInstructionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminBundesbankSettlementInstruction> {
        const response = await this.adminBundesbankSettlementInstructionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Activate the campaign.
     */
    async adminCampaignsActivationCreateRaw(requestParameters: AdminCampaignsActivationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminCampaignsActivationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/campaigns/{id}/activation/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CampaignActivationRequestToJSON(requestParameters['campaignActivationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Activate the campaign.
     */
    async adminCampaignsActivationCreate(requestParameters: AdminCampaignsActivationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminCampaignsActivationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Allows an admin to create an investment for a specific investor on their behalf.  Usually, these investors were created userless through Cashlink Studio.
     */
    async adminCampaignsInvestmentsCreateRaw(requestParameters: AdminCampaignsInvestmentsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvestmentCreation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminCampaignsInvestmentsCreate().'
            );
        }

        if (requestParameters['adminInvestmentCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminInvestmentCreationRequest',
                'Required parameter "adminInvestmentCreationRequest" was null or undefined when calling adminCampaignsInvestmentsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/campaigns/{id}/investments/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminInvestmentCreationRequestToJSON(requestParameters['adminInvestmentCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvestmentCreationFromJSON(jsonValue));
    }

    /**
     * Allows an admin to create an investment for a specific investor on their behalf.  Usually, these investors were created userless through Cashlink Studio.
     */
    async adminCampaignsInvestmentsCreate(requestParameters: AdminCampaignsInvestmentsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvestmentCreation> {
        const response = await this.adminCampaignsInvestmentsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminCampaignsListRaw(requestParameters: AdminCampaignsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminCampaignList>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/campaigns/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminCampaignListFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminCampaignsList(requestParameters: AdminCampaignsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminCampaignList> {
        const response = await this.adminCampaignsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a campaign.
     */
    async adminCampaignsRetrieveRaw(requestParameters: AdminCampaignsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminCampaign>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminCampaignsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/campaigns/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminCampaignFromJSON(jsonValue));
    }

    /**
     * Retrieve a campaign.
     */
    async adminCampaignsRetrieve(requestParameters: AdminCampaignsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminCampaign> {
        const response = await this.adminCampaignsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminFriendVouchersListRaw(requestParameters: AdminFriendVouchersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminVoucherList>> {
        const queryParameters: any = {};

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['alreadyUsedMax'] != null) {
            queryParameters['already_used_max'] = requestParameters['alreadyUsedMax'];
        }

        if (requestParameters['alreadyUsedMin'] != null) {
            queryParameters['already_used_min'] = requestParameters['alreadyUsedMin'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/friend-vouchers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminVoucherListFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminFriendVouchersList(requestParameters: AdminFriendVouchersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminVoucherList> {
        const response = await this.adminFriendVouchersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve Friend vouchers
     */
    async adminFriendVouchersRetrieveRaw(requestParameters: AdminFriendVouchersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminVoucherDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminFriendVouchersRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/friend-vouchers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminVoucherDetailFromJSON(jsonValue));
    }

    /**
     * Retrieve Friend vouchers
     */
    async adminFriendVouchersRetrieve(requestParameters: AdminFriendVouchersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminVoucherDetail> {
        const response = await this.adminFriendVouchersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all investment transfers, issuances and redemptions that have `investment_id` as source or recipient Investment.
     */
    async adminInvestmentTransfersListRaw(requestParameters: AdminInvestmentTransfersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdminTokenTransfer>>> {
        if (requestParameters['investment'] == null) {
            throw new runtime.RequiredError(
                'investment',
                'Required parameter "investment" was null or undefined when calling adminInvestmentTransfersList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['investment'] != null) {
            queryParameters['investment'] = requestParameters['investment'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investment-transfers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminTokenTransferFromJSON));
    }

    /**
     * List all investment transfers, issuances and redemptions that have `investment_id` as source or recipient Investment.
     */
    async adminInvestmentTransfersList(requestParameters: AdminInvestmentTransfersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdminTokenTransfer>> {
        const response = await this.adminInvestmentTransfersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * cancel/reject specified investment by giving date and cancellation reason
     */
    async adminInvestmentsCancellationCreateRaw(requestParameters: AdminInvestmentsCancellationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsCancellationCreate().'
            );
        }

        if (requestParameters['investmentCancellationRequest'] == null) {
            throw new runtime.RequiredError(
                'investmentCancellationRequest',
                'Required parameter "investmentCancellationRequest" was null or undefined when calling adminInvestmentsCancellationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investments/{id}/cancellation/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvestmentCancellationRequestToJSON(requestParameters['investmentCancellationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * cancel/reject specified investment by giving date and cancellation reason
     */
    async adminInvestmentsCancellationCreate(requestParameters: AdminInvestmentsCancellationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestmentsCancellationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * List documents of the investment.
     */
    async adminInvestmentsDocumentsListRaw(requestParameters: AdminInvestmentsDocumentsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdminDocument>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsDocumentsList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investments/{id}/documents/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminDocumentFromJSON));
    }

    /**
     * List documents of the investment.
     */
    async adminInvestmentsDocumentsList(requestParameters: AdminInvestmentsDocumentsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdminDocument>> {
        const response = await this.adminInvestmentsDocumentsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsIssueCreateRaw(requestParameters: AdminInvestmentsIssueCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsIssueCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investments/{id}/issue/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsIssueCreate(requestParameters: AdminInvestmentsIssueCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestmentsIssueCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsIssuingAnnouncementCreateRaw(requestParameters: AdminInvestmentsIssuingAnnouncementCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsIssuingAnnouncementCreate().'
            );
        }

        if (requestParameters['investmentIssuingAnnouncementRequest'] == null) {
            throw new runtime.RequiredError(
                'investmentIssuingAnnouncementRequest',
                'Required parameter "investmentIssuingAnnouncementRequest" was null or undefined when calling adminInvestmentsIssuingAnnouncementCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investments/{id}/issuing-announcement/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvestmentIssuingAnnouncementRequestToJSON(requestParameters['investmentIssuingAnnouncementRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsIssuingAnnouncementCreate(requestParameters: AdminInvestmentsIssuingAnnouncementCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestmentsIssuingAnnouncementCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsListRaw(requestParameters: AdminInvestmentsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminInvestmentList>> {
        const queryParameters: any = {};

        if (requestParameters['campaign'] != null) {
            queryParameters['campaign'] = requestParameters['campaign'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['frontendStatus'] != null) {
            queryParameters['frontend_status'] = requestParameters['frontendStatus'];
        }

        if (requestParameters['fulfilledAmountMax'] != null) {
            queryParameters['fulfilled_amount_max'] = requestParameters['fulfilledAmountMax'];
        }

        if (requestParameters['fulfilledAmountMin'] != null) {
            queryParameters['fulfilled_amount_min'] = requestParameters['fulfilledAmountMin'];
        }

        if (requestParameters['investmentTotalFulfilledMax'] != null) {
            queryParameters['investment_total_fulfilled_max'] = requestParameters['investmentTotalFulfilledMax'];
        }

        if (requestParameters['investmentTotalFulfilledMin'] != null) {
            queryParameters['investment_total_fulfilled_min'] = requestParameters['investmentTotalFulfilledMin'];
        }

        if (requestParameters['investmentTotalMax'] != null) {
            queryParameters['investment_total_max'] = requestParameters['investmentTotalMax'];
        }

        if (requestParameters['investmentTotalMin'] != null) {
            queryParameters['investment_total_min'] = requestParameters['investmentTotalMin'];
        }

        if (requestParameters['investor'] != null) {
            queryParameters['investor'] = requestParameters['investor'];
        }

        if (requestParameters['investorName'] != null) {
            queryParameters['investor_name'] = requestParameters['investorName'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['paymentCode'] != null) {
            queryParameters['payment_code'] = requestParameters['paymentCode'];
        }

        if (requestParameters['paymentTotalMax'] != null) {
            queryParameters['payment_total_max'] = requestParameters['paymentTotalMax'];
        }

        if (requestParameters['paymentTotalMin'] != null) {
            queryParameters['payment_total_min'] = requestParameters['paymentTotalMin'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['signedDateAfter'] != null) {
            queryParameters['signed_date_after'] = (requestParameters['signedDateAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['signedDateBefore'] != null) {
            queryParameters['signed_date_before'] = (requestParameters['signedDateBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['step'] != null) {
            queryParameters['step'] = requestParameters['step'];
        }

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investments/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminInvestmentListFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsList(requestParameters: AdminInvestmentsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminInvestmentList> {
        const response = await this.adminInvestmentsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * approve specified investment offer
     */
    async adminInvestmentsOfferApprovalCreateRaw(requestParameters: AdminInvestmentsOfferApprovalCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsOfferApprovalCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investments/{id}/offer-approval/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * approve specified investment offer
     */
    async adminInvestmentsOfferApprovalCreate(requestParameters: AdminInvestmentsOfferApprovalCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestmentsOfferApprovalCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsPartialUpdateRaw(requestParameters: AdminInvestmentsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvestmentDetails>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investments/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminInvestmentDetailsRequestToJSON(requestParameters['patchedAdminInvestmentDetailsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvestmentDetailsFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsPartialUpdate(requestParameters: AdminInvestmentsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvestmentDetails> {
        const response = await this.adminInvestmentsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsPaymentConfirmationCreateRaw(requestParameters: AdminInvestmentsPaymentConfirmationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsPaymentConfirmationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investments/{id}/payment-confirmation/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsPaymentConfirmationCreate(requestParameters: AdminInvestmentsPaymentConfirmationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestmentsPaymentConfirmationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Creates a new registry statement for this investment.
     */
    async adminInvestmentsRegistryStatementsCreateRaw(requestParameters: AdminInvestmentsRegistryStatementsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsRegistryStatementsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investments/{id}/registry-statements/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateRegistryStatementRequestToJSON(requestParameters['createRegistryStatementRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Creates a new registry statement for this investment.
     */
    async adminInvestmentsRegistryStatementsCreate(requestParameters: AdminInvestmentsRegistryStatementsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestmentsRegistryStatementsCreateRaw(requestParameters, initOverrides);
    }

    /**
     * If the status of the latest compliance check is not \"approval\", the admin user can request new identity verification from the investor (same requirements as for the current platform admin action)  The actions can only be performed by admin users with the MANAGE_INVESTOR_AND_INVESTMENT_DATA permission
     */
    async adminInvestmentsRequestIdentificationCreateRaw(requestParameters: AdminInvestmentsRequestIdentificationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsRequestIdentificationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investments/{id}/request-identification/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * If the status of the latest compliance check is not \"approval\", the admin user can request new identity verification from the investor (same requirements as for the current platform admin action)  The actions can only be performed by admin users with the MANAGE_INVESTOR_AND_INVESTMENT_DATA permission
     */
    async adminInvestmentsRequestIdentificationCreate(requestParameters: AdminInvestmentsRequestIdentificationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestmentsRequestIdentificationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsRetrieveRaw(requestParameters: AdminInvestmentsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvestmentDetails>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investments/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvestmentDetailsFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsRetrieve(requestParameters: AdminInvestmentsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvestmentDetails> {
        const response = await this.adminInvestmentsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsUpdateRaw(requestParameters: AdminInvestmentsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvestmentDetails>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestmentsUpdate().'
            );
        }

        if (requestParameters['adminInvestmentDetailsRequest'] == null) {
            throw new runtime.RequiredError(
                'adminInvestmentDetailsRequest',
                'Required parameter "adminInvestmentDetailsRequest" was null or undefined when calling adminInvestmentsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investments/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AdminInvestmentDetailsRequestToJSON(requestParameters['adminInvestmentDetailsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvestmentDetailsFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestmentsUpdate(requestParameters: AdminInvestmentsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvestmentDetails> {
        const response = await this.adminInvestmentsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Confirms that all benefiting persons for of a legal investor are not pep
     */
    async adminInvestorsBenefitingPersonConfirmationCreateRaw(requestParameters: AdminInvestorsBenefitingPersonConfirmationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsBenefitingPersonConfirmationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/benefiting-person-confirmation/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Confirms that all benefiting persons for of a legal investor are not pep
     */
    async adminInvestorsBenefitingPersonConfirmationCreate(requestParameters: AdminInvestorsBenefitingPersonConfirmationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestorsBenefitingPersonConfirmationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * List/add benefiting persons.
     */
    async adminInvestorsBenefitingPersonsCreateRaw(requestParameters: AdminInvestorsBenefitingPersonsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BenefitingPerson>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsBenefitingPersonsCreate().'
            );
        }

        if (requestParameters['benefitingPersonRequest'] == null) {
            throw new runtime.RequiredError(
                'benefitingPersonRequest',
                'Required parameter "benefitingPersonRequest" was null or undefined when calling adminInvestorsBenefitingPersonsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/benefiting-persons/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BenefitingPersonRequestToJSON(requestParameters['benefitingPersonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BenefitingPersonFromJSON(jsonValue));
    }

    /**
     * List/add benefiting persons.
     */
    async adminInvestorsBenefitingPersonsCreate(requestParameters: AdminInvestorsBenefitingPersonsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BenefitingPerson> {
        const response = await this.adminInvestorsBenefitingPersonsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update or delete existing benefiting persons.
     */
    async adminInvestorsBenefitingPersonsDestroyRaw(requestParameters: AdminInvestorsBenefitingPersonsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsBenefitingPersonsDestroy().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling adminInvestorsBenefitingPersonsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/benefiting-persons/{person_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update or delete existing benefiting persons.
     */
    async adminInvestorsBenefitingPersonsDestroy(requestParameters: AdminInvestorsBenefitingPersonsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestorsBenefitingPersonsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * List/add benefiting persons.
     */
    async adminInvestorsBenefitingPersonsListRaw(requestParameters: AdminInvestorsBenefitingPersonsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<BenefitingPerson>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsBenefitingPersonsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/benefiting-persons/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BenefitingPersonFromJSON));
    }

    /**
     * List/add benefiting persons.
     */
    async adminInvestorsBenefitingPersonsList(requestParameters: AdminInvestorsBenefitingPersonsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<BenefitingPerson>> {
        const response = await this.adminInvestorsBenefitingPersonsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update or delete existing benefiting persons.
     */
    async adminInvestorsBenefitingPersonsPartialUpdateRaw(requestParameters: AdminInvestorsBenefitingPersonsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BenefitingPerson>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsBenefitingPersonsPartialUpdate().'
            );
        }

        if (requestParameters['personId'] == null) {
            throw new runtime.RequiredError(
                'personId',
                'Required parameter "personId" was null or undefined when calling adminInvestorsBenefitingPersonsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/benefiting-persons/{person_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"person_id"}}`, encodeURIComponent(String(requestParameters['personId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedBenefitingPersonRequestToJSON(requestParameters['patchedBenefitingPersonRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BenefitingPersonFromJSON(jsonValue));
    }

    /**
     * Update or delete existing benefiting persons.
     */
    async adminInvestorsBenefitingPersonsPartialUpdate(requestParameters: AdminInvestorsBenefitingPersonsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BenefitingPerson> {
        const response = await this.adminInvestorsBenefitingPersonsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a basic investor to be later completed through the update endpoint. If `company_name` is sent, we assume it\'s a legal person.
     */
    async adminInvestorsCreateRaw(requestParameters: AdminInvestorsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvestorCreation>> {
        if (requestParameters['adminInvestorCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminInvestorCreationRequest',
                'Required parameter "adminInvestorCreationRequest" was null or undefined when calling adminInvestorsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminInvestorCreationRequestToJSON(requestParameters['adminInvestorCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvestorCreationFromJSON(jsonValue));
    }

    /**
     * Create a basic investor to be later completed through the update endpoint. If `company_name` is sent, we assume it\'s a legal person.
     */
    async adminInvestorsCreate(requestParameters: AdminInvestorsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvestorCreation> {
        const response = await this.adminInvestorsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Execute a GDPR deletion of the investor.
     */
    async adminInvestorsDestroyRaw(requestParameters: AdminInvestorsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Execute a GDPR deletion of the investor.
     */
    async adminInvestorsDestroy(requestParameters: AdminInvestorsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestorsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Give the best current identification for given investor
     * Give the best current identification for given investor
     */
    async adminInvestorsIdentificationsBestCurrentRetrieveRaw(requestParameters: AdminInvestorsIdentificationsBestCurrentRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Identification>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsIdentificationsBestCurrentRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/identifications/best-current/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentificationFromJSON(jsonValue));
    }

    /**
     * Give the best current identification for given investor
     * Give the best current identification for given investor
     */
    async adminInvestorsIdentificationsBestCurrentRetrieve(requestParameters: AdminInvestorsIdentificationsBestCurrentRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Identification> {
        const response = await this.adminInvestorsIdentificationsBestCurrentRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an identification instance for given investor.  Note: legitimation protocol document needs to be uploaded beforehand.
     * Create identfication for investor
     */
    async adminInvestorsIdentificationsCreateRaw(requestParameters: AdminInvestorsIdentificationsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Identification>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsIdentificationsCreate().'
            );
        }

        if (requestParameters['identificationRequest'] == null) {
            throw new runtime.RequiredError(
                'identificationRequest',
                'Required parameter "identificationRequest" was null or undefined when calling adminInvestorsIdentificationsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/identifications/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentificationRequestToJSON(requestParameters['identificationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentificationFromJSON(jsonValue));
    }

    /**
     * Create an identification instance for given investor.  Note: legitimation protocol document needs to be uploaded beforehand.
     * Create identfication for investor
     */
    async adminInvestorsIdentificationsCreate(requestParameters: AdminInvestorsIdentificationsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Identification> {
        const response = await this.adminInvestorsIdentificationsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all identifications for given investor
     * List all identifications of given investor
     */
    async adminInvestorsIdentificationsListRaw(requestParameters: AdminInvestorsIdentificationsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedIdentificationList>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsIdentificationsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/identifications/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedIdentificationListFromJSON(jsonValue));
    }

    /**
     * List all identifications for given investor
     * List all identifications of given investor
     */
    async adminInvestorsIdentificationsList(requestParameters: AdminInvestorsIdentificationsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedIdentificationList> {
        const response = await this.adminInvestorsIdentificationsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Restart all invalid associated identifications.
     * Abort all existing identifications and create a new one
     */
    async adminInvestorsIdentificationsRestartCreateRaw(requestParameters: AdminInvestorsIdentificationsRestartCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Identification>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsIdentificationsRestartCreate().'
            );
        }

        if (requestParameters['identificationRequest'] == null) {
            throw new runtime.RequiredError(
                'identificationRequest',
                'Required parameter "identificationRequest" was null or undefined when calling adminInvestorsIdentificationsRestartCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/identifications/restart/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentificationRequestToJSON(requestParameters['identificationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentificationFromJSON(jsonValue));
    }

    /**
     * Restart all invalid associated identifications.
     * Abort all existing identifications and create a new one
     */
    async adminInvestorsIdentificationsRestartCreate(requestParameters: AdminInvestorsIdentificationsRestartCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Identification> {
        const response = await this.adminInvestorsIdentificationsRestartCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List investors who were created through Cashlink Studio and are incomplete.  In this case incomplete means that they don\'t have all the necessary data and therefor don\'t have a valid manual KYC approved, so they can\'t have investments yet.
     */
    async adminInvestorsIncompleteListRaw(requestParameters: AdminInvestorsIncompleteListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdminInvestorList>>> {
        const queryParameters: any = {};

        if (requestParameters['activeInvestmentsNoMax'] != null) {
            queryParameters['active_investments_no_max'] = requestParameters['activeInvestmentsNoMax'];
        }

        if (requestParameters['activeInvestmentsNoMin'] != null) {
            queryParameters['active_investments_no_min'] = requestParameters['activeInvestmentsNoMin'];
        }

        if (requestParameters['activeInvestmentsSumMax'] != null) {
            queryParameters['active_investments_sum_max'] = requestParameters['activeInvestmentsSumMax'];
        }

        if (requestParameters['activeInvestmentsSumMin'] != null) {
            queryParameters['active_investments_sum_min'] = requestParameters['activeInvestmentsSumMin'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['registeredAtAfter'] != null) {
            queryParameters['registered_at_after'] = (requestParameters['registeredAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['registeredAtBefore'] != null) {
            queryParameters['registered_at_before'] = (requestParameters['registeredAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        if (requestParameters['tokenIdIsnull'] != null) {
            queryParameters['token_id_isnull'] = requestParameters['tokenIdIsnull'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/incomplete/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminInvestorListFromJSON));
    }

    /**
     * List investors who were created through Cashlink Studio and are incomplete.  In this case incomplete means that they don\'t have all the necessary data and therefor don\'t have a valid manual KYC approved, so they can\'t have investments yet.
     */
    async adminInvestorsIncompleteList(requestParameters: AdminInvestorsIncompleteListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdminInvestorList>> {
        const response = await this.adminInvestorsIncompleteListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestorsLegalPersonCreateRaw(requestParameters: AdminInvestorsLegalPersonCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminLegalPersonUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsLegalPersonCreate().'
            );
        }

        if (requestParameters['adminLegalPersonUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'adminLegalPersonUpdateRequest',
                'Required parameter "adminLegalPersonUpdateRequest" was null or undefined when calling adminInvestorsLegalPersonCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/legal-person/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminLegalPersonUpdateRequestToJSON(requestParameters['adminLegalPersonUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminLegalPersonUpdateFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvestorsLegalPersonCreate(requestParameters: AdminInvestorsLegalPersonCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminLegalPersonUpdate> {
        const response = await this.adminInvestorsLegalPersonCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List investors
     */
    async adminInvestorsListRaw(requestParameters: AdminInvestorsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminInvestorListList>> {
        const queryParameters: any = {};

        if (requestParameters['activeInvestmentsNoMax'] != null) {
            queryParameters['active_investments_no_max'] = requestParameters['activeInvestmentsNoMax'];
        }

        if (requestParameters['activeInvestmentsNoMin'] != null) {
            queryParameters['active_investments_no_min'] = requestParameters['activeInvestmentsNoMin'];
        }

        if (requestParameters['activeInvestmentsSumMax'] != null) {
            queryParameters['active_investments_sum_max'] = requestParameters['activeInvestmentsSumMax'];
        }

        if (requestParameters['activeInvestmentsSumMin'] != null) {
            queryParameters['active_investments_sum_min'] = requestParameters['activeInvestmentsSumMin'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['email'] != null) {
            queryParameters['email'] = requestParameters['email'];
        }

        if (requestParameters['lastName'] != null) {
            queryParameters['last_name'] = requestParameters['lastName'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['registeredAtAfter'] != null) {
            queryParameters['registered_at_after'] = (requestParameters['registeredAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['registeredAtBefore'] != null) {
            queryParameters['registered_at_before'] = (requestParameters['registeredAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        if (requestParameters['tokenIdIsnull'] != null) {
            queryParameters['token_id_isnull'] = requestParameters['tokenIdIsnull'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminInvestorListListFromJSON(jsonValue));
    }

    /**
     * List investors
     */
    async adminInvestorsList(requestParameters: AdminInvestorsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminInvestorListList> {
        const response = await this.adminInvestorsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all mails sent to given investor.  The permissions must be one of: 1) a mail related to a token for which the user has InvestmentTokenPermission.VIEW_DATA 2) the user has DistributionPlatformPermission.VIEW_PLATFORM_DATA for investor.distribution_platform
     * List all mails sent to given investor
     */
    async adminInvestorsMailsListRaw(requestParameters: AdminInvestorsMailsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminMailList>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsMailsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['sendAtAfter'] != null) {
            queryParameters['send_at_after'] = (requestParameters['sendAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['sendAtBefore'] != null) {
            queryParameters['send_at_before'] = (requestParameters['sendAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/mails/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminMailListFromJSON(jsonValue));
    }

    /**
     * List all mails sent to given investor.  The permissions must be one of: 1) a mail related to a token for which the user has InvestmentTokenPermission.VIEW_DATA 2) the user has DistributionPlatformPermission.VIEW_PLATFORM_DATA for investor.distribution_platform
     * List all mails sent to given investor
     */
    async adminInvestorsMailsList(requestParameters: AdminInvestorsMailsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminMailList> {
        const response = await this.adminInvestorsMailsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing investor.
     */
    async adminInvestorsPartialUpdateRaw(requestParameters: AdminInvestorsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminInvestorUpdateRequestToJSON(requestParameters['patchedAdminInvestorUpdateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update an existing investor.
     */
    async adminInvestorsPartialUpdate(requestParameters: AdminInvestorsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestorsPartialUpdateRaw(requestParameters, initOverrides);
    }

    /**
     * Add/retrieve a pending deletion request that gets executed as soon as legally possible.
     */
    async adminInvestorsPendingDeletionCreateRaw(requestParameters: AdminInvestorsPendingDeletionCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminPendingInvestorDeletion>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsPendingDeletionCreate().'
            );
        }

        if (requestParameters['adminPendingInvestorDeletionRequest'] == null) {
            throw new runtime.RequiredError(
                'adminPendingInvestorDeletionRequest',
                'Required parameter "adminPendingInvestorDeletionRequest" was null or undefined when calling adminInvestorsPendingDeletionCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/pending-deletion/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminPendingInvestorDeletionRequestToJSON(requestParameters['adminPendingInvestorDeletionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminPendingInvestorDeletionFromJSON(jsonValue));
    }

    /**
     * Add/retrieve a pending deletion request that gets executed as soon as legally possible.
     */
    async adminInvestorsPendingDeletionCreate(requestParameters: AdminInvestorsPendingDeletionCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminPendingInvestorDeletion | null | undefined > {
        const response = await this.adminInvestorsPendingDeletionCreateRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 201:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Add/retrieve a pending deletion request that gets executed as soon as legally possible.
     */
    async adminInvestorsPendingDeletionRetrieveRaw(requestParameters: AdminInvestorsPendingDeletionRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminPendingInvestorDeletion>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsPendingDeletionRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/pending-deletion/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminPendingInvestorDeletionFromJSON(jsonValue));
    }

    /**
     * Add/retrieve a pending deletion request that gets executed as soon as legally possible.
     */
    async adminInvestorsPendingDeletionRetrieve(requestParameters: AdminInvestorsPendingDeletionRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminPendingInvestorDeletion | null | undefined > {
        const response = await this.adminInvestorsPendingDeletionRetrieveRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 201:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Reactivate an investor which has a pending deletion.
     */
    async adminInvestorsReactivateCreateRaw(requestParameters: AdminInvestorsReactivateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsReactivateCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/reactivate/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Reactivate an investor which has a pending deletion.
     */
    async adminInvestorsReactivateCreate(requestParameters: AdminInvestorsReactivateCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvestorsReactivateCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Detail view of an investor.
     */
    async adminInvestorsRetrieveRaw(requestParameters: AdminInvestorsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvestor>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvestorFromJSON(jsonValue));
    }

    /**
     * Detail view of an investor.
     */
    async adminInvestorsRetrieve(requestParameters: AdminInvestorsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvestor> {
        const response = await this.adminInvestorsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a confirmed ERC20 wallet for a given investor.
     */
    async adminInvestorsWalletsEthGenericCreateRaw(requestParameters: AdminInvestorsWalletsEthGenericCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminGenericWalletCreation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsWalletsEthGenericCreate().'
            );
        }

        if (requestParameters['adminGenericWalletCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminGenericWalletCreationRequest',
                'Required parameter "adminGenericWalletCreationRequest" was null or undefined when calling adminInvestorsWalletsEthGenericCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/wallets/eth-generic/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminGenericWalletCreationRequestToJSON(requestParameters['adminGenericWalletCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminGenericWalletCreationFromJSON(jsonValue));
    }

    /**
     * Creates a confirmed ERC20 wallet for a given investor.
     */
    async adminInvestorsWalletsEthGenericCreate(requestParameters: AdminInvestorsWalletsEthGenericCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminGenericWalletCreation> {
        const response = await this.adminInvestorsWalletsEthGenericCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a wallet for a given investor
     */
    async adminInvestorsWalletsPartialUpdateRaw(requestParameters: AdminInvestorsWalletsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WalletUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvestorsWalletsPartialUpdate().'
            );
        }

        if (requestParameters['walletId'] == null) {
            throw new runtime.RequiredError(
                'walletId',
                'Required parameter "walletId" was null or undefined when calling adminInvestorsWalletsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/investors/{id}/wallets/{wallet_id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"wallet_id"}}`, encodeURIComponent(String(requestParameters['walletId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedWalletUpdateRequestToJSON(requestParameters['patchedWalletUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WalletUpdateFromJSON(jsonValue));
    }

    /**
     * Update a wallet for a given investor
     */
    async adminInvestorsWalletsPartialUpdate(requestParameters: AdminInvestorsWalletsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WalletUpdate> {
        const response = await this.adminInvestorsWalletsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * revoke investment invitation
     */
    async adminInvitationsDestroyRaw(requestParameters: AdminInvitationsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvitationsDestroy().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/invitations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * revoke investment invitation
     */
    async adminInvitationsDestroy(requestParameters: AdminInvitationsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvitationsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve an identification. Create it if it does not exists.
     */
    async adminInvitationsIdentificationRetrieveRaw(requestParameters: AdminInvitationsIdentificationRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<KycInformation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvitationsIdentificationRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/invitations/{id}/identification/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => KycInformationFromJSON(jsonValue));
    }

    /**
     * Retrieve an identification. Create it if it does not exists.
     */
    async adminInvitationsIdentificationRetrieve(requestParameters: AdminInvitationsIdentificationRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<KycInformation> {
        const response = await this.adminInvitationsIdentificationRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Set the KYC status of an identification to \'started\'.
     */
    async adminInvitationsIdentificationStartNotificationCreateRaw(requestParameters: AdminInvitationsIdentificationStartNotificationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvitationsIdentificationStartNotificationCreate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/invitations/{id}/identification-start-notification/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Set the KYC status of an identification to \'started\'.
     */
    async adminInvitationsIdentificationStartNotificationCreate(requestParameters: AdminInvitationsIdentificationStartNotificationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminInvitationsIdentificationStartNotificationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * list invitations
     */
    async adminInvitationsListRaw(requestParameters: AdminInvitationsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedInvitationList>> {
        const queryParameters: any = {};

        if (requestParameters['campaignId'] != null) {
            queryParameters['campaign_id'] = requestParameters['campaignId'];
        }

        if (requestParameters['invitationType'] != null) {
            queryParameters['invitation_type'] = requestParameters['invitationType'];
        }

        if (requestParameters['isEcsp'] != null) {
            queryParameters['is_ecsp'] = requestParameters['isEcsp'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/invitations/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedInvitationListFromJSON(jsonValue));
    }

    /**
     * list invitations
     */
    async adminInvitationsList(requestParameters: AdminInvitationsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedInvitationList> {
        const response = await this.adminInvitationsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvitationsRetrieveRaw(requestParameters: AdminInvitationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvitation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminInvitationsRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tokenId'] != null) {
            queryParameters['token_id'] = requestParameters['tokenId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/invitations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvitationFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminInvitationsRetrieve(requestParameters: AdminInvitationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvitation> {
        const response = await this.adminInvitationsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an issuer.
     */
    async adminIssuersCreateRaw(requestParameters: AdminIssuersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminIssuerDetail>> {
        if (requestParameters['adminIssuerCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminIssuerCreationRequest',
                'Required parameter "adminIssuerCreationRequest" was null or undefined when calling adminIssuersCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/issuers/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminIssuerCreationRequestToJSON(requestParameters['adminIssuerCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminIssuerDetailFromJSON(jsonValue));
    }

    /**
     * Create an issuer.
     */
    async adminIssuersCreate(requestParameters: AdminIssuersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminIssuerDetail> {
        const response = await this.adminIssuersCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List issuers.
     */
    async adminIssuersListRaw(requestParameters: AdminIssuersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminIssuerListList>> {
        const queryParameters: any = {};

        if (requestParameters['canCreateProduct'] != null) {
            queryParameters['can_create_product'] = requestParameters['canCreateProduct'];
        }

        if (requestParameters['issuerId'] != null) {
            queryParameters['issuer_id'] = requestParameters['issuerId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['numberOfProductsMax'] != null) {
            queryParameters['number_of_products_max'] = requestParameters['numberOfProductsMax'];
        }

        if (requestParameters['numberOfProductsMin'] != null) {
            queryParameters['number_of_products_min'] = requestParameters['numberOfProductsMin'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/issuers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminIssuerListListFromJSON(jsonValue));
    }

    /**
     * List issuers.
     */
    async adminIssuersList(requestParameters: AdminIssuersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminIssuerListList> {
        const response = await this.adminIssuersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing issuer.
     */
    async adminIssuersPartialUpdateRaw(requestParameters: AdminIssuersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminIssuerDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminIssuersPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/issuers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminIssuerUpdateRequestToJSON(requestParameters['patchedAdminIssuerUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminIssuerDetailFromJSON(jsonValue));
    }

    /**
     * Update an existing issuer.
     */
    async adminIssuersPartialUpdate(requestParameters: AdminIssuersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminIssuerDetail> {
        const response = await this.adminIssuersPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Detail view of an issuer.
     */
    async adminIssuersRetrieveRaw(requestParameters: AdminIssuersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminIssuerDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminIssuersRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/issuers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminIssuerDetailFromJSON(jsonValue));
    }

    /**
     * Detail view of an issuer.
     */
    async adminIssuersRetrieve(requestParameters: AdminIssuersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminIssuerDetail> {
        const response = await this.adminIssuersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a ProductDistributionPlatformListing for the current product.
     */
    async adminListingsCreateRaw(requestParameters: AdminListingsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductDistributionPlatformListingCreation>> {
        if (requestParameters['adminProductDistributionPlatformListingCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductDistributionPlatformListingCreationRequest',
                'Required parameter "adminProductDistributionPlatformListingCreationRequest" was null or undefined when calling adminListingsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/listings/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminProductDistributionPlatformListingCreationRequestToJSON(requestParameters['adminProductDistributionPlatformListingCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProductDistributionPlatformListingCreationFromJSON(jsonValue));
    }

    /**
     * Create a ProductDistributionPlatformListing for the current product.
     */
    async adminListingsCreate(requestParameters: AdminListingsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductDistributionPlatformListingCreation> {
        const response = await this.adminListingsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Access or edit the distributor\'s distribution information of this product listing.
     */
    async adminListingsDistributionInformationCreateRaw(requestParameters: AdminListingsDistributionInformationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDistributorProductDistributionInformation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminListingsDistributionInformationCreate().'
            );
        }

        if (requestParameters['adminDistributorProductDistributionInformationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminDistributorProductDistributionInformationRequest',
                'Required parameter "adminDistributorProductDistributionInformationRequest" was null or undefined when calling adminListingsDistributionInformationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/listings/{id}/distribution-information/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminDistributorProductDistributionInformationRequestToJSON(requestParameters['adminDistributorProductDistributionInformationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminDistributorProductDistributionInformationFromJSON(jsonValue));
    }

    /**
     * Access or edit the distributor\'s distribution information of this product listing.
     */
    async adminListingsDistributionInformationCreate(requestParameters: AdminListingsDistributionInformationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDistributorProductDistributionInformation | null | undefined > {
        const response = await this.adminListingsDistributionInformationCreateRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Access or edit the distributor\'s distribution information of this product listing.
     */
    async adminListingsDistributionInformationPartialUpdateRaw(requestParameters: AdminListingsDistributionInformationPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDistributorProductDistributionInformation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminListingsDistributionInformationPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/listings/{id}/distribution-information/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminDistributorProductDistributionInformationRequestToJSON(requestParameters['patchedAdminDistributorProductDistributionInformationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminDistributorProductDistributionInformationFromJSON(jsonValue));
    }

    /**
     * Access or edit the distributor\'s distribution information of this product listing.
     */
    async adminListingsDistributionInformationPartialUpdate(requestParameters: AdminListingsDistributionInformationPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDistributorProductDistributionInformation | null | undefined > {
        const response = await this.adminListingsDistributionInformationPartialUpdateRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Access or edit the distributor\'s distribution information of this product listing.
     */
    async adminListingsDistributionInformationRetrieveRaw(requestParameters: AdminListingsDistributionInformationRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminDistributorProductDistributionInformation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminListingsDistributionInformationRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/listings/{id}/distribution-information/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminDistributorProductDistributionInformationFromJSON(jsonValue));
    }

    /**
     * Access or edit the distributor\'s distribution information of this product listing.
     */
    async adminListingsDistributionInformationRetrieve(requestParameters: AdminListingsDistributionInformationRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminDistributorProductDistributionInformation | null | undefined > {
        const response = await this.adminListingsDistributionInformationRetrieveRaw(requestParameters, initOverrides);
        switch (response.raw.status) {
            case 200:
                return await response.value();
            case 204:
                return null;
            default:
                return await response.value();
        }
    }

    /**
     * Get or add investment documents for a listing.
     */
    async adminListingsInvestmentDocumentsCreateRaw(requestParameters: AdminListingsInvestmentDocumentsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminBulkInvestmentDocumentCreation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminListingsInvestmentDocumentsCreate().'
            );
        }

        if (requestParameters['adminBulkInvestmentDocumentCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminBulkInvestmentDocumentCreationRequest',
                'Required parameter "adminBulkInvestmentDocumentCreationRequest" was null or undefined when calling adminListingsInvestmentDocumentsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/listings/{id}/investment-documents/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminBulkInvestmentDocumentCreationRequestToJSON(requestParameters['adminBulkInvestmentDocumentCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminBulkInvestmentDocumentCreationFromJSON(jsonValue));
    }

    /**
     * Get or add investment documents for a listing.
     */
    async adminListingsInvestmentDocumentsCreate(requestParameters: AdminListingsInvestmentDocumentsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminBulkInvestmentDocumentCreation> {
        const response = await this.adminListingsInvestmentDocumentsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get or add investment documents for a listing.
     */
    async adminListingsInvestmentDocumentsRetrieveRaw(requestParameters: AdminListingsInvestmentDocumentsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminInvestmentDocument>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminListingsInvestmentDocumentsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/listings/{id}/investment-documents/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminInvestmentDocumentFromJSON(jsonValue));
    }

    /**
     * Get or add investment documents for a listing.
     */
    async adminListingsInvestmentDocumentsRetrieve(requestParameters: AdminListingsInvestmentDocumentsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminInvestmentDocument> {
        const response = await this.adminListingsInvestmentDocumentsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List listings
     */
    async adminListingsListRaw(requestParameters: AdminListingsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminProductDistributionPlatformListingList>> {
        const queryParameters: any = {};

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/listings/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminProductDistributionPlatformListingListFromJSON(jsonValue));
    }

    /**
     * List listings
     */
    async adminListingsList(requestParameters: AdminListingsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminProductDistributionPlatformListingList> {
        const response = await this.adminListingsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a listing.
     */
    async adminListingsRetrieveRaw(requestParameters: AdminListingsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductDistributionPlatformListing>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminListingsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/listings/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProductDistributionPlatformListingFromJSON(jsonValue));
    }

    /**
     * Retrieve a listing.
     */
    async adminListingsRetrieve(requestParameters: AdminListingsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductDistributionPlatformListing> {
        const response = await this.adminListingsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminMailsListRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdminMail>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/mails/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminMailFromJSON));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminMailsList(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdminMail>> {
        const response = await this.adminMailsListRaw(initOverrides);
        return await response.value();
    }

    /**
     * Resend the current mail
     */
    async adminMailsResendCreateRaw(requestParameters: AdminMailsResendCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminMailsResendCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/mails/{id}/resend/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Resend the current mail
     */
    async adminMailsResendCreate(requestParameters: AdminMailsResendCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminMailsResendCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Detail view of a mail.
     */
    async adminMailsRetrieveRaw(requestParameters: AdminMailsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminMail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminMailsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/mails/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminMailFromJSON(jsonValue));
    }

    /**
     * Detail view of a mail.
     */
    async adminMailsRetrieve(requestParameters: AdminMailsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminMail> {
        const response = await this.adminMailsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async adminOverviewRetrieveRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminTokenGlobalOverview>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/overview/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminTokenGlobalOverviewFromJSON(jsonValue));
    }

    /**
     */
    async adminOverviewRetrieve(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminTokenGlobalOverview> {
        const response = await this.adminOverviewRetrieveRaw(initOverrides);
        return await response.value();
    }

    /**
     * Create a PayoutEvent.
     */
    async adminPayoutEventsCreateRaw(requestParameters: AdminPayoutEventsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminPayoutEvent>> {
        if (requestParameters['adminPayoutEventCreationOrUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'adminPayoutEventCreationOrUpdateRequest',
                'Required parameter "adminPayoutEventCreationOrUpdateRequest" was null or undefined when calling adminPayoutEventsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/payout-events/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminPayoutEventCreationOrUpdateRequestToJSON(requestParameters['adminPayoutEventCreationOrUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminPayoutEventFromJSON(jsonValue));
    }

    /**
     * Create a PayoutEvent.
     */
    async adminPayoutEventsCreate(requestParameters: AdminPayoutEventsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminPayoutEvent> {
        const response = await this.adminPayoutEventsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get PayoutEvents.
     */
    async adminPayoutEventsListRaw(requestParameters: AdminPayoutEventsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminPayoutEventList>> {
        const queryParameters: any = {};

        if (requestParameters['issuerId'] != null) {
            queryParameters['issuer_id'] = requestParameters['issuerId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['paymentDateAfter'] != null) {
            queryParameters['payment_date_after'] = (requestParameters['paymentDateAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['paymentDateBefore'] != null) {
            queryParameters['payment_date_before'] = (requestParameters['paymentDateBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['payoutEventType'] != null) {
            queryParameters['payout_event_type'] = requestParameters['payoutEventType'];
        }

        if (requestParameters['productId'] != null) {
            queryParameters['product_id'] = requestParameters['productId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/payout-events/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminPayoutEventListFromJSON(jsonValue));
    }

    /**
     * Get PayoutEvents.
     */
    async adminPayoutEventsList(requestParameters: AdminPayoutEventsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminPayoutEventList> {
        const response = await this.adminPayoutEventsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update PayoutEvent.
     * Update a PayoutEvent
     */
    async adminPayoutEventsPartialUpdateRaw(requestParameters: AdminPayoutEventsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminPayoutEventCreationOrUpdate>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminPayoutEventsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/payout-events/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminPayoutEventRequestToJSON(requestParameters['patchedAdminPayoutEventRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminPayoutEventCreationOrUpdateFromJSON(jsonValue));
    }

    /**
     * Update PayoutEvent.
     * Update a PayoutEvent
     */
    async adminPayoutEventsPartialUpdate(requestParameters: AdminPayoutEventsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminPayoutEventCreationOrUpdate> {
        const response = await this.adminPayoutEventsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a PayoutEvent.
     */
    async adminPayoutEventsRetrieveRaw(requestParameters: AdminPayoutEventsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminPayoutEvent>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminPayoutEventsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/payout-events/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminPayoutEventFromJSON(jsonValue));
    }

    /**
     * Get a PayoutEvent.
     */
    async adminPayoutEventsRetrieve(requestParameters: AdminPayoutEventsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminPayoutEvent> {
        const response = await this.adminPayoutEventsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminRedemptionsCreateRaw(requestParameters: AdminRedemptionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Redemption>> {
        if (requestParameters['redemptionRequest'] == null) {
            throw new runtime.RequiredError(
                'redemptionRequest',
                'Required parameter "redemptionRequest" was null or undefined when calling adminRedemptionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/redemptions/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RedemptionRequestToJSON(requestParameters['redemptionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RedemptionFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminRedemptionsCreate(requestParameters: AdminRedemptionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Redemption> {
        const response = await this.adminRedemptionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminRedemptionsRetrieveRaw(requestParameters: AdminRedemptionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Redemption>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminRedemptionsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/redemptions/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RedemptionFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminRedemptionsRetrieve(requestParameters: AdminRedemptionsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Redemption> {
        const response = await this.adminRedemptionsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Only allow one Report to be generated at a time If a report is running longer then settings.STATISTICS_REPORT_TIMEOUT mark it as not succeeded
     */
    async adminStatisticsReportRetrieveRaw(requestParameters: AdminStatisticsReportRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Statistics>> {
        if (requestParameters['reportType'] == null) {
            throw new runtime.RequiredError(
                'reportType',
                'Required parameter "reportType" was null or undefined when calling adminStatisticsReportRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['reportType'] != null) {
            queryParameters['report_type'] = requestParameters['reportType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/statistics-report/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatisticsFromJSON(jsonValue));
    }

    /**
     * Only allow one Report to be generated at a time If a report is running longer then settings.STATISTICS_REPORT_TIMEOUT mark it as not succeeded
     */
    async adminStatisticsReportRetrieve(requestParameters: AdminStatisticsReportRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Statistics> {
        const response = await this.adminStatisticsReportRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Allows an admin to create an Bundesbank settlement instruction.
     */
    async adminTokensBundesbankSettlementInstructionsCreateRaw(requestParameters: AdminTokensBundesbankSettlementInstructionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminBundesbankSettlementInstruction>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminTokensBundesbankSettlementInstructionsCreate().'
            );
        }

        if (requestParameters['adminBundesbankSettlementInstructionRequest'] == null) {
            throw new runtime.RequiredError(
                'adminBundesbankSettlementInstructionRequest',
                'Required parameter "adminBundesbankSettlementInstructionRequest" was null or undefined when calling adminTokensBundesbankSettlementInstructionsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/tokens/{id}/bundesbank-settlement-instructions/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminBundesbankSettlementInstructionRequestToJSON(requestParameters['adminBundesbankSettlementInstructionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminBundesbankSettlementInstructionFromJSON(jsonValue));
    }

    /**
     * Allows an admin to create an Bundesbank settlement instruction.
     */
    async adminTokensBundesbankSettlementInstructionsCreate(requestParameters: AdminTokensBundesbankSettlementInstructionsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminBundesbankSettlementInstruction> {
        const response = await this.adminTokensBundesbankSettlementInstructionsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get calculations.
     */
    async adminTokensCalculationsRetrieveRaw(requestParameters: AdminTokensCalculationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestmentCalculation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminTokensCalculationsRetrieve().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pricePerToken'] != null) {
            queryParameters['price_per_token'] = requestParameters['pricePerToken'];
        }

        if (requestParameters['requestedTokens'] != null) {
            queryParameters['requested_tokens'] = requestParameters['requestedTokens'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/tokens/{id}/calculations/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestmentCalculationFromJSON(jsonValue));
    }

    /**
     * Get calculations.
     */
    async adminTokensCalculationsRetrieve(requestParameters: AdminTokensCalculationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestmentCalculation> {
        const response = await this.adminTokensCalculationsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a campaign for the given product.
     */
    async adminTokensCampaignsCreateRaw(requestParameters: AdminTokensCampaignsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Campaign>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminTokensCampaignsCreate().'
            );
        }

        if (requestParameters['campaignRequest'] == null) {
            throw new runtime.RequiredError(
                'campaignRequest',
                'Required parameter "campaignRequest" was null or undefined when calling adminTokensCampaignsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/tokens/{id}/campaigns/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CampaignRequestToJSON(requestParameters['campaignRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignFromJSON(jsonValue));
    }

    /**
     * Create a campaign for the given product.
     */
    async adminTokensCampaignsCreate(requestParameters: AdminTokensCampaignsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Campaign> {
        const response = await this.adminTokensCampaignsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create and possibly deploy a product.
     */
    async adminTokensCreateRaw(requestParameters: AdminTokensCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductDetail>> {
        if (requestParameters['adminProductCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminProductCreationRequest',
                'Required parameter "adminProductCreationRequest" was null or undefined when calling adminTokensCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/tokens/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminProductCreationRequestToJSON(requestParameters['adminProductCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProductDetailFromJSON(jsonValue));
    }

    /**
     * Create and possibly deploy a product.
     */
    async adminTokensCreate(requestParameters: AdminTokensCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductDetail> {
        const response = await this.adminTokensCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create an investment invitation.
     */
    async adminTokensInvitationCreateRaw(requestParameters: AdminTokensInvitationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvestmentInvitation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminTokensInvitationCreate().'
            );
        }

        if (requestParameters['investmentInvitationCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'investmentInvitationCreationRequest',
                'Required parameter "investmentInvitationCreationRequest" was null or undefined when calling adminTokensInvitationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/tokens/{id}/invitation/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvestmentInvitationCreationRequestToJSON(requestParameters['investmentInvitationCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvestmentInvitationFromJSON(jsonValue));
    }

    /**
     * Create an investment invitation.
     */
    async adminTokensInvitationCreate(requestParameters: AdminTokensInvitationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvestmentInvitation> {
        const response = await this.adminTokensInvitationCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get issuer rules.
     */
    async adminTokensInvitationRulesListRaw(requestParameters: AdminTokensInvitationRulesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<IssuerInvestmentRules>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminTokensInvitationRulesList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['issuerId'] != null) {
            queryParameters['issuer_id'] = requestParameters['issuerId'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['totalVolumeMax'] != null) {
            queryParameters['total_volume_max'] = requestParameters['totalVolumeMax'];
        }

        if (requestParameters['totalVolumeMin'] != null) {
            queryParameters['total_volume_min'] = requestParameters['totalVolumeMin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/tokens/{id}/invitation-rules/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IssuerInvestmentRulesFromJSON));
    }

    /**
     * Get issuer rules.
     */
    async adminTokensInvitationRulesList(requestParameters: AdminTokensInvitationRulesListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<IssuerInvestmentRules>> {
        const response = await this.adminTokensInvitationRulesListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Add new issuance document.
     */
    async adminTokensIssuanceDocumentCreateRaw(requestParameters: AdminTokensIssuanceDocumentCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminVersionedIssuanceDocument>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminTokensIssuanceDocumentCreate().'
            );
        }

        if (requestParameters['adminVersionedIssuanceDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'adminVersionedIssuanceDocumentRequest',
                'Required parameter "adminVersionedIssuanceDocumentRequest" was null or undefined when calling adminTokensIssuanceDocumentCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/tokens/{id}/issuance-document/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminVersionedIssuanceDocumentRequestToJSON(requestParameters['adminVersionedIssuanceDocumentRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminVersionedIssuanceDocumentFromJSON(jsonValue));
    }

    /**
     * Add new issuance document.
     */
    async adminTokensIssuanceDocumentCreate(requestParameters: AdminTokensIssuanceDocumentCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminVersionedIssuanceDocument> {
        const response = await this.adminTokensIssuanceDocumentCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List products.
     */
    async adminTokensListRaw(requestParameters: AdminTokensListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminProductDetailList>> {
        const queryParameters: any = {};

        if (requestParameters['id'] != null) {
            queryParameters['id'] = requestParameters['id'];
        }

        if (requestParameters['issuerId'] != null) {
            queryParameters['issuer_id'] = requestParameters['issuerId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['totalVolumeMax'] != null) {
            queryParameters['total_volume_max'] = requestParameters['totalVolumeMax'];
        }

        if (requestParameters['totalVolumeMin'] != null) {
            queryParameters['total_volume_min'] = requestParameters['totalVolumeMin'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/tokens/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminProductDetailListFromJSON(jsonValue));
    }

    /**
     * List products.
     */
    async adminTokensList(requestParameters: AdminTokensListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminProductDetailList> {
        const response = await this.adminTokensListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get overview of token (product).
     */
    async adminTokensOverviewRetrieveRaw(requestParameters: AdminTokensOverviewRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminTokenOverview>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminTokensOverviewRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/tokens/{id}/overview/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminTokenOverviewFromJSON(jsonValue));
    }

    /**
     * Get overview of token (product).
     */
    async adminTokensOverviewRetrieve(requestParameters: AdminTokensOverviewRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminTokenOverview> {
        const response = await this.adminTokensOverviewRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing product.
     * Update a product
     */
    async adminTokensPartialUpdateRaw(requestParameters: AdminTokensPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminTokensPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/tokens/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminProductDetailRequestToJSON(requestParameters['patchedAdminProductDetailRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProductDetailFromJSON(jsonValue));
    }

    /**
     * Update an existing product.
     * Update a product
     */
    async adminTokensPartialUpdate(requestParameters: AdminTokensPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductDetail> {
        const response = await this.adminTokensPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List eWpG registry statement documents from this product.
     */
    async adminTokensRegistryStatementsListRaw(requestParameters: AdminTokensRegistryStatementsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminRegistryStatementList>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminTokensRegistryStatementsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/tokens/{id}/registry-statements/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminRegistryStatementListFromJSON(jsonValue));
    }

    /**
     * List eWpG registry statement documents from this product.
     */
    async adminTokensRegistryStatementsList(requestParameters: AdminTokensRegistryStatementsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminRegistryStatementList> {
        const response = await this.adminTokensRegistryStatementsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a product.
     */
    async adminTokensRetrieveRaw(requestParameters: AdminTokensRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminProductDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminTokensRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/tokens/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminProductDetailFromJSON(jsonValue));
    }

    /**
     * Get a product.
     */
    async adminTokensRetrieve(requestParameters: AdminTokensRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminProductDetail> {
        const response = await this.adminTokensRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminVouchersActivationCreateRaw(requestParameters: AdminVouchersActivationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminVouchersActivationCreate().'
            );
        }

        if (requestParameters['adminVoucherRequest'] == null) {
            throw new runtime.RequiredError(
                'adminVoucherRequest',
                'Required parameter "adminVoucherRequest" was null or undefined when calling adminVouchersActivationCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/vouchers/{id}/activation/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminVoucherRequestToJSON(requestParameters['adminVoucherRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminVouchersActivationCreate(requestParameters: AdminVouchersActivationCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminVouchersActivationCreateRaw(requestParameters, initOverrides);
    }

    /**
     * Create voucher.
     */
    async adminVouchersCreateRaw(requestParameters: AdminVouchersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminVoucherCreation>> {
        if (requestParameters['adminVoucherCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'adminVoucherCreationRequest',
                'Required parameter "adminVoucherCreationRequest" was null or undefined when calling adminVouchersCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/vouchers/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminVoucherCreationRequestToJSON(requestParameters['adminVoucherCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminVoucherCreationFromJSON(jsonValue));
    }

    /**
     * Create voucher.
     */
    async adminVouchersCreate(requestParameters: AdminVouchersCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminVoucherCreation> {
        const response = await this.adminVouchersCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminVouchersInvestmentsListRaw(requestParameters: AdminVouchersInvestmentsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedInvestmentDetailsList>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminVouchersInvestmentsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['campaign'] != null) {
            queryParameters['campaign'] = requestParameters['campaign'];
        }

        if (requestParameters['distributionPlatformId'] != null) {
            queryParameters['distribution_platform_id'] = requestParameters['distributionPlatformId'];
        }

        if (requestParameters['fulfilledAmountMax'] != null) {
            queryParameters['fulfilled_amount_max'] = requestParameters['fulfilledAmountMax'];
        }

        if (requestParameters['fulfilledAmountMin'] != null) {
            queryParameters['fulfilled_amount_min'] = requestParameters['fulfilledAmountMin'];
        }

        if (requestParameters['investmentTotalFulfilledMax'] != null) {
            queryParameters['investment_total_fulfilled_max'] = requestParameters['investmentTotalFulfilledMax'];
        }

        if (requestParameters['investmentTotalFulfilledMin'] != null) {
            queryParameters['investment_total_fulfilled_min'] = requestParameters['investmentTotalFulfilledMin'];
        }

        if (requestParameters['investmentTotalMax'] != null) {
            queryParameters['investment_total_max'] = requestParameters['investmentTotalMax'];
        }

        if (requestParameters['investmentTotalMin'] != null) {
            queryParameters['investment_total_min'] = requestParameters['investmentTotalMin'];
        }

        if (requestParameters['investorName'] != null) {
            queryParameters['investor_name'] = requestParameters['investorName'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['paymentCode'] != null) {
            queryParameters['payment_code'] = requestParameters['paymentCode'];
        }

        if (requestParameters['paymentTotalMax'] != null) {
            queryParameters['payment_total_max'] = requestParameters['paymentTotalMax'];
        }

        if (requestParameters['paymentTotalMin'] != null) {
            queryParameters['payment_total_min'] = requestParameters['paymentTotalMin'];
        }

        if (requestParameters['productName'] != null) {
            queryParameters['product_name'] = requestParameters['productName'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['signedDateAfter'] != null) {
            queryParameters['signed_date_after'] = (requestParameters['signedDateAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['signedDateBefore'] != null) {
            queryParameters['signed_date_before'] = (requestParameters['signedDateBefore'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/vouchers/{id}/investments/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedInvestmentDetailsListFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminVouchersInvestmentsList(requestParameters: AdminVouchersInvestmentsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedInvestmentDetailsList> {
        const response = await this.adminVouchersInvestmentsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminVouchersListRaw(requestParameters: AdminVouchersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedAdminVoucherList>> {
        const queryParameters: any = {};

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['alreadyUsedMax'] != null) {
            queryParameters['already_used_max'] = requestParameters['alreadyUsedMax'];
        }

        if (requestParameters['alreadyUsedMin'] != null) {
            queryParameters['already_used_min'] = requestParameters['alreadyUsedMin'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/vouchers/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedAdminVoucherListFromJSON(jsonValue));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminVouchersList(requestParameters: AdminVouchersListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedAdminVoucherList> {
        const response = await this.adminVouchersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a voucher.
     */
    async adminVouchersPartialUpdateRaw(requestParameters: AdminVouchersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminVouchersPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/vouchers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedAdminVoucherUpdateRequestToJSON(requestParameters['patchedAdminVoucherUpdateRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a voucher.
     */
    async adminVouchersPartialUpdate(requestParameters: AdminVouchersPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.adminVouchersPartialUpdateRaw(requestParameters, initOverrides);
    }

    /**
     * Get voucher.
     */
    async adminVouchersRetrieveRaw(requestParameters: AdminVouchersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminVoucherDetail>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminVouchersRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/vouchers/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminVoucherDetailFromJSON(jsonValue));
    }

    /**
     * Get voucher.
     */
    async adminVouchersRetrieve(requestParameters: AdminVouchersRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminVoucherDetail> {
        const response = await this.adminVouchersRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Given a voucher\'s code, and investor and a token; it responds wether it is a valid code or not.
     */
    async adminVouchersValidatorCreateRaw(requestParameters: AdminVouchersValidatorCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AdminVoucherValidator>> {
        if (requestParameters['adminVoucherValidatorRequest'] == null) {
            throw new runtime.RequiredError(
                'adminVoucherValidatorRequest',
                'Required parameter "adminVoucherValidatorRequest" was null or undefined when calling adminVouchersValidatorCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/vouchers/validator/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminVoucherValidatorRequestToJSON(requestParameters['adminVoucherValidatorRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AdminVoucherValidatorFromJSON(jsonValue));
    }

    /**
     * Given a voucher\'s code, and investor and a token; it responds wether it is a valid code or not.
     */
    async adminVouchersValidatorCreate(requestParameters: AdminVouchersValidatorCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AdminVoucherValidator> {
        const response = await this.adminVouchersValidatorCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminVouchersVoucherStepsCreateRaw(requestParameters: AdminVouchersVoucherStepsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdminVoucherStep>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminVouchersVoucherStepsCreate().'
            );
        }

        if (requestParameters['adminVoucherStepBulkCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'adminVoucherStepBulkCreateRequest',
                'Required parameter "adminVoucherStepBulkCreateRequest" was null or undefined when calling adminVouchersVoucherStepsCreate().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['alreadyUsedMax'] != null) {
            queryParameters['already_used_max'] = requestParameters['alreadyUsedMax'];
        }

        if (requestParameters['alreadyUsedMin'] != null) {
            queryParameters['already_used_min'] = requestParameters['alreadyUsedMin'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/vouchers/{id}/voucher-steps/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AdminVoucherStepBulkCreateRequestToJSON(requestParameters['adminVoucherStepBulkCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminVoucherStepFromJSON));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminVouchersVoucherStepsCreate(requestParameters: AdminVouchersVoucherStepsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdminVoucherStep>> {
        const response = await this.adminVouchersVoucherStepsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminVouchersVoucherStepsListRaw(requestParameters: AdminVouchersVoucherStepsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdminVoucherStep>>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling adminVouchersVoucherStepsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['active'] != null) {
            queryParameters['active'] = requestParameters['active'];
        }

        if (requestParameters['alreadyUsedMax'] != null) {
            queryParameters['already_used_max'] = requestParameters['alreadyUsedMax'];
        }

        if (requestParameters['alreadyUsedMin'] != null) {
            queryParameters['already_used_min'] = requestParameters['alreadyUsedMin'];
        }

        if (requestParameters['code'] != null) {
            queryParameters['code'] = requestParameters['code'];
        }

        if (requestParameters['createdAtAfter'] != null) {
            queryParameters['created_at_after'] = (requestParameters['createdAtAfter'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['createdAtBefore'] != null) {
            queryParameters['created_at_before'] = (requestParameters['createdAtBefore'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/admin/vouchers/{id}/voucher-steps/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminVoucherStepFromJSON));
    }

    /**
     * Mixin to add TX retry functionality to classes inheriting from APIView, such as GenericAPIView.  By default handlers are assumed TX safe, and thus will be retryable.
     */
    async adminVouchersVoucherStepsList(requestParameters: AdminVouchersVoucherStepsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdminVoucherStep>> {
        const response = await this.adminVouchersVoucherStepsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const AdminInvestmentsListFrontendStatusEnum = {
    ABORTED: 'Aborted',
    ACCEPTANCE_MISSING: 'AcceptanceMissing',
    ADDITIONAL_INFORMATION_PENDING: 'AdditionalInformationPending',
    CANCELED_KYC_INSUFFICIENT: 'CanceledKycInsufficient',
    CANCELED_PAYMENT_MISSING: 'CanceledPaymentMissing',
    CANCELLATION: 'Cancellation',
    FINISHED: 'Finished',
    HANDOVER: 'Handover',
    IDENTIFICATION_COMPLIANCE_PENDING: 'IdentificationCompliancePending',
    IDENTIFICATION_PENDING: 'IdentificationPending',
    PAYMENT_PENDING: 'PaymentPending',
    REJECTED: 'Rejected',
    SECURITIES_TRANSFERRED: 'SecuritiesTransferred',
    SECURITY_TRANSFER_MISSING: 'SecurityTransferMissing',
    SUCCESS_FULLY_TRANSFERED: 'SuccessFullyTransfered',
    SUCCESS_PARTIALLY_TRANSFERED: 'SuccessPartiallyTransfered',
    SUCCESS_REDEEMED: 'SuccessRedeemed',
    TAX_INFORMATION_MISSING: 'TaxInformationMissing',
    TRANSACTION_FAILED: 'TransactionFailed',
    TRANSACTION_PENDING: 'TransactionPending',
    TRANSACTION_SUCCEEDED: 'TransactionSucceeded',
    WALLET_SETUP_PENDING: 'WalletSetupPending'
} as const;
export type AdminInvestmentsListFrontendStatusEnum = typeof AdminInvestmentsListFrontendStatusEnum[keyof typeof AdminInvestmentsListFrontendStatusEnum];
/**
 * @export
 */
export const AdminInvestmentsListStatusEnum = {
    ACCEPTABLE: 'acceptable',
    ALL: 'all',
    FINISHED: 'finished',
    NOT_DELETED: 'not-deleted',
    OPEN: 'open',
    PAID: 'paid',
    PAYMENT_OUTSTANDING: 'payment-outstanding',
    SECURITIES_OUTSTANDING: 'securities-outstanding'
} as const;
export type AdminInvestmentsListStatusEnum = typeof AdminInvestmentsListStatusEnum[keyof typeof AdminInvestmentsListStatusEnum];
/**
 * @export
 */
export const AdminInvestmentsListStepEnum = {
    ACCOUNT_SETUP: 'ACCOUNT_SETUP',
    ADDITIONAL_INFORMATION: 'ADDITIONAL_INFORMATION',
    BENEFICIARY: 'BENEFICIARY',
    CANCELED: 'CANCELED',
    CONFIRM_WALLET: 'CONFIRM_WALLET',
    FINAL: 'FINAL',
    IDENTIFICATION: 'IDENTIFICATION',
    IDENTIFICATION_FAILED: 'IDENTIFICATION_FAILED',
    IDENTIFICATION_REJECTED: 'IDENTIFICATION_REJECTED',
    INVESTMENT_AMOUNT: 'INVESTMENT_AMOUNT',
    OFFER_CREATION: 'OFFER_CREATION',
    PAYMENT: 'PAYMENT',
    PREPARE_ASSET: 'PREPARE_ASSET',
    QUESTIONNAIRE: 'QUESTIONNAIRE',
    RESUME_IDENTIFICATION: 'RESUME_IDENTIFICATION',
    SELECT_WALLET: 'SELECT_WALLET',
    SETUP_MOBILE_WALLET: 'SETUP_MOBILE_WALLET',
    TAX_INFORMATION: 'TAX_INFORMATION',
    UNCONFIRMED: 'UNCONFIRMED',
    VIB: 'VIB',
    WAITING_ACCEPTANCE: 'WAITING_ACCEPTANCE',
    WAITING_COMPLIANCE: 'WAITING_COMPLIANCE',
    WAITING_KYC: 'WAITING_KYC'
} as const;
export type AdminInvestmentsListStepEnum = typeof AdminInvestmentsListStepEnum[keyof typeof AdminInvestmentsListStepEnum];
/**
 * @export
 */
export const AdminInvestorsMailsListTypeEnum = {
    ADMIN: 'ADMIN',
    ADMIN_COMPLIANCE_NEW: 'ADMIN_COMPLIANCE_NEW',
    ADMIN_CRYPTOSECURITY_PUBLICATION_RESTRICTED: 'ADMIN_CRYPTOSECURITY_PUBLICATION_RESTRICTED',
    ADMIN_CRYPTOSECURITY_VALIDATION_REQUIRED: 'ADMIN_CRYPTOSECURITY_VALIDATION_REQUIRED',
    ADMIN_KYC_CALL_FOR_ACTION: 'ADMIN_KYC_CALL_FOR_ACTION',
    ADMIN_PAYOUT_EVENT_OCCURING: 'ADMIN_PAYOUT_EVENT_OCCURING',
    DEMO_INVESTOR_ACTIVATION: 'DEMO_INVESTOR_ACTIVATION',
    DEMO_ISSUER_ACTIVATION: 'DEMO_ISSUER_ACTIVATION',
    DEMO_ISSUER_START: 'DEMO_ISSUER_START',
    DISTRIBUTOR_DISTRIBUTION_INFORMATION_MISSING: 'DISTRIBUTOR_DISTRIBUTION_INFORMATION_MISSING',
    INVESTOR_2_FA_RESET: 'INVESTOR_2FA_RESET',
    INVESTOR_2_FA_SETUP: 'INVESTOR_2FA_SETUP',
    INVESTOR_COSTS: 'INVESTOR_COSTS',
    INVESTOR_DEPOT_ACTIVATION: 'INVESTOR_DEPOT_ACTIVATION',
    INVESTOR_EWPG_DOC: 'INVESTOR_EWPG_DOC',
    INVESTOR_INVESTMENT_CANCELLED_BY_ECSP_SWITCH: 'INVESTOR_INVESTMENT_CANCELLED_BY_ECSP_SWITCH',
    INVESTOR_INVESTMENT_CONSIDERATION_PERIOD: 'INVESTOR_INVESTMENT_CONSIDERATION_PERIOD',
    INVESTOR_INVESTMENT_EXPERIENCE_SUMMARY: 'INVESTOR_INVESTMENT_EXPERIENCE_SUMMARY',
    INVESTOR_KYC_SUCCESSFUL: 'INVESTOR_KYC_SUCCESSFUL',
    INVESTOR_OFFER_ACCEPTED: 'INVESTOR_OFFER_ACCEPTED',
    INVESTOR_OFFER_REJECTED: 'INVESTOR_OFFER_REJECTED',
    INVESTOR_PAYMENT_RECEIVED: 'INVESTOR_PAYMENT_RECEIVED',
    INVESTOR_PENDING_DELETION: 'INVESTOR_PENDING_DELETION',
    INVESTOR_PRODUCT_DOCUMENTS: 'INVESTOR_PRODUCT_DOCUMENTS',
    INVESTOR_REACTIVATED: 'INVESTOR_REACTIVATED',
    INVESTOR_REMINDER_ADDITIONAL_INFORMATION: 'INVESTOR_REMINDER_ADDITIONAL_INFORMATION',
    INVESTOR_REMINDER_COMMITMENT: 'INVESTOR_REMINDER_COMMITMENT',
    INVESTOR_REMINDER_IDENT: 'INVESTOR_REMINDER_IDENT',
    INVESTOR_REMINDER_PAYMENT: 'INVESTOR_REMINDER_PAYMENT',
    INVESTOR_REMINDER_QUESTIONNAIRE: 'INVESTOR_REMINDER_QUESTIONNAIRE',
    INVESTOR_REMINDER_WALLET: 'INVESTOR_REMINDER_WALLET',
    INVESTOR_TOKEN_SENT: 'INVESTOR_TOKEN_SENT',
    INVESTOR_TOKEN_TRANSFER_RECEIVED: 'INVESTOR_TOKEN_TRANSFER_RECEIVED',
    INVESTOR_TOS_UPDATE: 'INVESTOR_TOS_UPDATE',
    ISSUER_CRYPTOSECURITY_REJECTED: 'ISSUER_CRYPTOSECURITY_REJECTED',
    ISSUER_CRYPTOSECURITY_SUCCESSFUL: 'ISSUER_CRYPTOSECURITY_SUCCESSFUL',
    ISSUER_NEW_DOCUMENT: 'ISSUER_NEW_DOCUMENT',
    ISSUER_NEW_OFFER: 'ISSUER_NEW_OFFER',
    ISSUER_PAYMENT_INCOMING: 'ISSUER_PAYMENT_INCOMING',
    ISSUER_TOKEN_READY_TO_SEND: 'ISSUER_TOKEN_READY_TO_SEND',
    OFFBOARDING_HANDOVER_DOCS: 'OFFBOARDING_HANDOVER_DOCS',
    REDO_KYC: 'REDO_KYC',
    STATISTICS: 'STATISTICS',
    TRANSFER_INVITEE_READY: 'TRANSFER_INVITEE_READY',
    USER_EMAIL_CHANGED: 'USER_EMAIL_CHANGED',
    USER_EMAIL_CONFIRMATION: 'USER_EMAIL_CONFIRMATION',
    USER_RESET_PASSWORD: 'USER_RESET_PASSWORD',
    VOUCHER_FRIEND_REDEMPTION: 'VOUCHER_FRIEND_REDEMPTION'
} as const;
export type AdminInvestorsMailsListTypeEnum = typeof AdminInvestorsMailsListTypeEnum[keyof typeof AdminInvestorsMailsListTypeEnum];
/**
 * @export
 */
export const AdminPayoutEventsListPayoutEventTypeEnum = {
    DIVIDEND_PAYMENT: 'dividend_payment',
    INTEREST_PAYMENT: 'interest_payment',
    LIQUIDATION: 'liquidation',
    MATURITY_REDEMPTION: 'maturity_redemption'
} as const;
export type AdminPayoutEventsListPayoutEventTypeEnum = typeof AdminPayoutEventsListPayoutEventTypeEnum[keyof typeof AdminPayoutEventsListPayoutEventTypeEnum];
/**
 * @export
 */
export const AdminStatisticsReportRetrieveReportTypeEnum = {
    DISTRIBUTION_PLATFORM_EXPORT: 'DISTRIBUTION_PLATFORM_EXPORT',
    ISSUER_EXPORT: 'ISSUER_EXPORT'
} as const;
export type AdminStatisticsReportRetrieveReportTypeEnum = typeof AdminStatisticsReportRetrieveReportTypeEnum[keyof typeof AdminStatisticsReportRetrieveReportTypeEnum];
/**
 * @export
 */
export const AdminTokensInvitationRulesListStatusEnum = {
    CREATED: 'created',
    FAILED: 'failed',
    PROCESSING: 'processing',
    QUEUED: 'queued',
    SUCCEEDED: 'succeeded',
    UNKNOWN: 'unknown',
    VALIDATION_PENDING: 'validation_pending',
    VALIDATION_REJECTED: 'validation_rejected',
    VALIDATION_SUCCESS: 'validation_success',
    WAITING: 'waiting'
} as const;
export type AdminTokensInvitationRulesListStatusEnum = typeof AdminTokensInvitationRulesListStatusEnum[keyof typeof AdminTokensInvitationRulesListStatusEnum];
/**
 * @export
 */
export const AdminTokensListStatusEnum = {
    CREATED: 'created',
    FAILED: 'failed',
    PROCESSING: 'processing',
    QUEUED: 'queued',
    SUCCEEDED: 'succeeded',
    UNKNOWN: 'unknown',
    VALIDATION_PENDING: 'validation_pending',
    VALIDATION_REJECTED: 'validation_rejected',
    VALIDATION_SUCCESS: 'validation_success',
    WAITING: 'waiting'
} as const;
export type AdminTokensListStatusEnum = typeof AdminTokensListStatusEnum[keyof typeof AdminTokensListStatusEnum];
